// 应收费用池配置colum
export const chargeablePool = {
    configId: null,
    configTableId: 2,
    configDefaultColumn: [
        {label: '提货时间',prop: 'deliveryTimeNode',fixed: 'left',width: '105',check: true},
        {label: '客户名称',prop: 'orderInfo.customerName',fixed: 'left',width: '70',check: true},
        {label: '客户联系人',prop: 'orderInfo.customerContactName',fixed: 'left',width: '60',check: true},
        {label: '进仓单号',prop: 'orderInfo.inWarehouseNo',fixed: 'left',width: '60',check: true},
        {label: '订单类型',prop: 'orderInfo.orderTypeName',width: '60',check: true,fixed: undefined},
        {label: '报关方式',prop: 'orderInfo.entranceTypeName',width: '80',check: true,fixed: undefined},
        {label: '订单车型',prop: 'orderInfo.vehicleModelStr',width: '80',check: true,fixed: undefined},
        {label: '司机车牌',prop: 'vehiclePlan.vehiclePlate',width: '70',check: true,fixed: undefined},
        {label: '提货方',prop: 'factoryName',width: '100',check: true,fixed: undefined},
        {label: '起点',prop: 'route',width: '60',check: true,fixed: undefined},
        {label: '提货地址',prop: 'fullAddress',width: '180',check: true,fixed: undefined},
        {label: '卸货方',prop: 'giveAddressInfo.factoryName',width: '100',check: true,fixed: undefined},
        {label: '终点',prop: 'giveAddressInfo.route',width: '60',check: true,fixed: undefined},
        {label: '收货地址',prop: 'giveAddressInfo.fullAddress',width: '180',check: true,fixed: undefined},
        {label: '费用小计',prop: 'costInfo.totalMoneyV',width: '80',formatter: 'getNumValue',check: true,fixed: undefined},
        {label: '运费',prop: 'costInfo.freightFee',width: '80',formatter: 'getNumValue',check: true,fixed: undefined},
        {label: '报关/入仓费',prop: 'costInfo.entranceFee',width: '75',formatter: 'getNumValue',check: true,fixed: undefined},
        {label: '高速费',prop: 'costInfo.highFee',width: '50',formatter: 'getNumValue',check: true,fixed: undefined},
        {label: '过磅费',prop: 'costInfo.weighFee',width: '50',formatter: 'getNumValue',check: true,fixed: undefined},
        {label: '装卸费',prop: 'costInfo.loadFee',width: '50',formatter: 'getNumValue',check: true,fixed: undefined},
        {label: '押夜/超时费',prop: 'costInfo.overtimeFee',width: '70',formatter: 'getNumValue',check: true,fixed: undefined},
        {label: '提货费',prop: 'costInfo.takeFee',width: '50',formatter: 'getNumValue',check: true,fixed: undefined},
        {label: '停车费',prop: 'costInfo.parkingFee',width: '50',formatter: 'getNumValue',check: true,fixed: undefined},
        {label: '加点费',prop: 'costInfo.addFee',width: '50',formatter: 'getNumValue',check: true,fixed: undefined},
        {label: '其他费用',prop: 'costInfo.otherFee',width: '60',formatter: 'getNumValue',check: true,fixed: undefined},
        {label: '其他费用备注',prop: 'otherFeeRemark',width: '60',check: true,fixed: undefined},
        {label: '预收费用',prop: 'costInfo.receivedFee',width: '60',formatter: 'getNumValue',check: true,fixed: undefined},
        {label: '预收备注',prop: 'costInfo.receivedRemark',width: '60',formatter: 'getNumValue',check: true,fixed: undefined},
        {label: '客服备注',prop: 'orderInfo.companyRemark',width: '60',formatter: 'getNumValue',check: true,fixed: undefined},
        {label: '件数',prop: 'orderGoods.pieceNum',width: '60',check: true,fixed: undefined},
        {label: '体积',prop: 'orderGoods.volume',width: '40',check: true,fixed: undefined},
        {label: '重量',prop: 'orderGoods.weight',width: '40',check: true,fixed: undefined},
        {label: '司机姓名',prop: 'vehiclePlan.driverName',width: '60',check: true,fixed: undefined},
        {label: '司机电话',prop: 'vehiclePlan.driverPhone',width: '90',check: true,fixed: undefined,formatter: 'maskMobileTable'},
        {label: '客户单号',prop: 'orderInfo.customerSelfNo',width: '100',check: true,fixed: undefined},
        {label: '客户联系电话',prop: 'orderInfo.customerContactPhone',width: '90',check: true,fixed: undefined,formatter: 'maskMobileTable'},
        {label: '下单时间',prop: 'orderInfo.commitTime',width: '120',check: true,fixed: undefined},
        {label: '下单人',prop: 'orderInfo.commitName',width: '50',check: true,fixed: undefined},
        {label: '订单号',prop: 'orderInfo.orderNo',width: '110',check: true,fixed: undefined},
        {label: '车次号',prop: 'vehiclePlan.planNo',width: '110',check: true,fixed: undefined},
        {label: '收款人',prop: 'costInfo.writeName',width: '50',check: true,fixed: undefined},
        {label: '收款时间',prop: 'costInfo.writeDate',width: '70',check: true,fixed: undefined},
        {label: '账单状态',fixed: 'right',prop: 'costInfo.genStatusName',width: '60',check: true},
        {label: '收款状态',fixed: 'right',prop: 'costInfo.writeStatusName',width: '60',check: true},
    ],
    configDefaultPropColumn: [],
    isConfigMode: false,
    configModeForm: {
        name: '',
        remark: '',
        defaultOrNot: '0'
    },
}

// 客户月账单colum
export const monthBill = {
    configId: null,
    configTableId: 28,
    configDefaultColumn: [
        {label: '客户名称',prop: 'customerName',fixed: undefined,width: '100',check: true},
        {label: '账单名称',prop: 'name',fixed: undefined,width: undefined,check: true},
        {label: '账单编号',prop: 'billNo',fixed: undefined,width: '120',check: true},
        {label: '账单订单数',prop: 'orderNum',fixed: undefined,width: '80',check: true},
        {label: '账单总金额',prop: 'totalMoney',fixed: undefined,width: '80',check: true},
        {label: '发送状态',prop: 'sendStatus',fixed: undefined,width: '60',check: true},
        {label: '发送时间',prop: 'sendTime',fixed: undefined,width: '130',check: true},
        {label: '账单生成日期',prop: 'createTime',fixed: undefined,width: '130',check: true},
        {label: '账单开始日期',prop: 'beginTime',fixed: undefined,width: '90',check: true},
        {label: '账单结束日期',prop: 'endTime',fixed: undefined,width: '90',check: true},
    ],
    configDefaultPropColumn: [],
    isConfigMode: false,
    configModeForm: {
        name: '',
        remark: '',
        defaultOrNot: '0'
    },
    configDefaultPropColumnMap: new Map(),
}

// 订单列表(内部)
export const orderListInternal = {
    configId: null,
    configTableId: 4,
    configDefaultColumn: [
        {label: '分享',prop: 'driverBusinessCardSharingWechat',fixed: 'left',width: '40',check: true},
        {label: '客户名称',prop: 'orderInfo.customerName',width: '100',check: true,fixed: undefined},
        {label: '客户联系人',prop: 'orderInfo.customerContactName',width: '100',check: true,fixed: undefined},
        {label: '提货时间',prop: 'deliveryTimeNode',width: '105',check: true,fixed: undefined},
        {label: '进仓单号',prop: 'orderInfo.inWarehouseNo',width: '70',check: true,fixed: undefined},
        {label: '订单类型',prop: 'orderInfo.orderType',width: '60',formatter: 'orderType',check: true,fixed: undefined},
        {label: '所需车型',prop: 'orderInfo.vehicleType',width: '80',formatter: 'dictConvertVehicle',check: true,fixed: undefined},
        {label: '司机车牌',prop: 'vehiclePlan.vehiclePlate',width: '70',check: true,fixed: undefined},
        {label: 'GPS/APP定位',prop: 'gpsAndAppPositioning',width: '70',check: true,fixed: undefined},
        {label: '距终点/预计耗时',prop: 'estimatedTimeConsumptionToTheFinishLine',width: '70',check: true,fixed: undefined},
        {label: '报关方式',prop: 'orderInfo.entranceType',width: '80',formatter: 'entranceType',check: true,fixed: undefined},
        {label: '提货方',prop: 'factoryName',width: '75',check: true,fixed: undefined},
        {label: '提货地址',prop: 'fullAddress',width: '180',check: true,fixed: undefined},
        {label: '提货联系人',prop: 'contactName',width: '70',check: true,fixed: undefined},
        {label: '提货电话',prop: 'contactPhone',width: '85',check: true,fixed: undefined,formatter: 'maskMobileTable'},
        {label: '注意事项',prop: 'takeRemark',width: '60',check: true,fixed: undefined},
        {label: '卸货方',prop: 'giveAddressInfo.factoryName',width: '75"',check: true,fixed: undefined},
        {label: '收货地址',prop: 'giveAddressInfo.fullAddress',width: '180"',check: true,fixed: undefined},
        {label: '收货联系人',prop: 'giveAddressInfo.contactName',width: '70"',check: true,fixed: undefined},
        {label: '收货电话',prop: 'giveAddressInfo.contactPhone',width: '85"',check: true,fixed: undefined,formatter: 'maskMobileTable'},
        {label: '公里数(KM)',prop: 'orderInfo.distance',width: '85"',formatter: 'getDistanceValue',check: true,fixed: undefined},
        {label: '件数',prop: 'orderGoods.pieceNum',width: '40"',check: true,fixed: undefined},
        {label: '体积',prop: 'orderGoods.volume',width: '40"',check: true,fixed: undefined},
        {label: '重量',prop: 'orderGoods.weight',width: '40"',check: true,fixed: undefined},
        {label: '货物尺寸(长/宽/高)',prop: 'orderGoods.length',width: '110"',check: true,fixed: undefined},
        {label: '包装类型',prop: 'orderGoods.packType',width: '60',formatter: 'manyDictConvert',check: true,fixed: undefined},
        {label: '货物备注',prop: 'orderGoods.remark',width: '110"',check: true,fixed: undefined},
        {label: '是否尾板',prop: 'orderInfo.isTailstock',width: '70"',formatter: 'yesNo',check: true,fixed: undefined},
        {label: '订单号',prop: 'orderInfo.orderNo',width: '105"',check: true,fixed: undefined},
        {label: '客户单号',prop: 'orderInfo.customerSelfNo',width: '70"',check: true,fixed: undefined},
        {label: '客户联系电话',prop: 'orderInfo.customerContactPhone',width: '90"',check: true,fixed: undefined,formatter: 'maskMobileTable'},
        {label: '司机姓名',prop: 'vehiclePlan.driverName',width: '60"',check: true,fixed: undefined},
        {label: '司机电话',prop: 'vehiclePlan.driverPhone',width: '90"',check: true,fixed: undefined,formatter: 'maskMobileTable'},
        {label: '下单时间',prop: 'orderInfo.commitTime',width: '120"',check: true,fixed: undefined},
        {label: '跟单员',prop: 'careAccountName',fixed: undefined,width: '60"',check: true},
        {label: '回单寄出时间',prop: 'orderInfo.receiptSendTime',width: '120"',check: true,fixed: undefined},
        {label: '回单收件人',prop: 'orderInfo.receiptAddressee',width: '70"',check: true,fixed: undefined},
        {label: '状态',prop: 'status',fixed: 'right',width: '70"',check: true},
        {label: '签收单状态',prop: 'orderInfo.writeStatus',fixed: 'right',width: '70"',check: true},
        {label: '回单状态',prop: '回单状态',fixed: 'right',width: '60"',check: true},
    ],
    configDefaultPropColumn: [],
    isConfigMode: false,
    configModeForm: {
        name: '',
        remark: '',
        defaultOrNot: '0'
    },
}

// 版本
export const versionV = {
    configId: null,
    configTableId: 57,
    configDefaultColumn: [
        {label: '版本号',prop: 'name',check: true,fixed: undefined},
        {label: '版本链接',prop: 'link',check: true,fixed: undefined},
        {label: '版本终端',prop: 'terminal',check: true,fixed: undefined},
        {label: '版本类型',prop: 'type',check: true,fixed: undefined},
        {label: '版本状态',prop: 'status',check: true,fixed: undefined},
        {label: '版本备注',prop: 'remark',check: true,fixed: undefined},
        {label: '创建账号',prop: 'createdName',check: true,fixed: undefined},
        {label: '创建时间',prop: 'createTime',check: true,fixed: undefined},
        {label: '修改时间',prop: 'updateTime',check: true,fixed: undefined},
    ],
    configDefaultPropColumn: [],
    isConfigMode: false,
    configModeForm: {
        name: '',
        remark: '',
        defaultOrNot: '0'
    },
    configDefaultPropColumnMap: new Map(),
}

// 驾驶员运力
export const driverInfo = {
    configId: null,
    configTableId: 36,
    configDefaultColumn: [
        {label: '驾驶员姓名',prop: 'name',check: true,fixed: undefined},
        {label: '联系电话',prop: 'contactPhone',width: '90',check: true,fixed: undefined,formatter: 'maskMobileTable'},
        {label: '现居地址',prop: 'address',check: true,fixed: undefined},
        {label: '籍贯',prop: 'nativeCity',check: true,fixed: undefined},
        {label: '身份证号码',prop: 'cardNo',width: '130',check: true,fixed: undefined},
        {label: '身份证照片',prop: '身份证照片',width: '70',check: true,fixed: undefined},
        {label: '驾驶证照片',prop: '驾驶证照片',width: '70',check: true,fixed: undefined},
        {label: '准驾类型',prop: 'proofType',formatter: 'dictConvert',width: '60',check: true,fixed: undefined},
        {label: '自带车',prop: 'isHaveVehicle',formatter: 'yesNo',width: '50',check: true,fixed: undefined},
        {label: '紧急联系电话',prop: 'urgentPhone',check: true,fixed: undefined,formatter: 'maskMobileTable'},
        {label: '所属车队',prop: 'motorcadeName',check: true,fixed: undefined},
        {label: '车队长',prop: 'captain',formatter: 'yesNo',check: true,fixed: undefined,width: '50'},
        {label: '入职日期',prop: 'entryDate',check: true,fixed: undefined},
        {label: '实际出勤工资',prop: 'baseWage',check: true,fixed: undefined},
        {label: '基本工资',prop: 'basicSalaryDisplay',check: true,fixed: undefined},
        {label: '出勤天数',prop: 'dutyDay',check: true,fixed: undefined},
        {label: '全勤奖',prop: 'fullDutyFee',check: true,fixed: undefined},
        {label: '油耗奖励',prop: 'other2Reward',check: true,fixed: undefined},
        {label: '状态',prop: 'status',width: '50',check: true,fixed: undefined},
        {label: '微信黑名单',prop: 'weChatBlacklistStatus',width: '80',check: true,fixed: undefined},
    ],
    configDefaultPropColumn: [],
    isConfigMode: false,
    configModeForm: {
        name: '',
        remark: '',
        defaultOrNot: '0'
    },
    configDefaultPropColumnMap: new Map(),
}

// 调度平台-订单管理-已调度
export const dispatched = {
    configId: null,
    configTableId: 10,
    configDefaultColumn: [
        {label: '分享',prop: 'driverBusinessCardSharingWechat',fixed: 'left',width: '40',check: true},
        {label: '状态',prop: '状态',width: '50',check: true,fixed: 'left'},
        {label: '客户名称',prop: 'orderInfo.customerName',width: '80',check: true,fixed: undefined},
        {label: '客户联系人',prop: 'orderInfo.customerContactName',width: '70',check: true,fixed: undefined},
        {label: '提货时间',prop: 'orderInfo.takeGoodsDate',width: '105',check: true,fixed: undefined},
        {label: '订单类型',prop: 'orderInfo.orderType',width: '60',formatter: 'orderType',check: true,fixed: undefined},
        {label: '所需车型',prop: 'orderInfo.vehicleType',width: '80',formatter: 'dictConvert',check: true,fixed: undefined},
        {label: '司机姓名',prop: 'vehiclePlan.driverName',width: '80',check: true,fixed: undefined},
        {label: '司机车牌',prop: 'vehiclePlan.vehiclePlate',width: '70',check: true,fixed: undefined},
        {label: '报关方式',prop: 'orderInfo.entranceType',width: '80',formatter: 'entranceType',check: true,fixed: undefined},
        {label: '提货方',prop: 'factoryName',width: '75',check: true,fixed: undefined},
        {label: '提货地址',prop: 'fullAddress',width: '150',check: true,fixed: undefined},
        {label: '提货联系人',prop: 'contactName',width: '70',check: true,fixed: undefined},
        {label: '提货联系人电话',prop: 'contactPhone',width: '85',check: true,fixed: undefined,formatter: 'maskMobileTable'},
        {label: '提货注意事项',prop: 'takeRemark',width: '85',check: true,fixed: undefined},
        {label: '卸货方',prop: 'giveAddressInfo.factoryName',width: '75"',check: true,fixed: undefined},
        {label: '收货地址',prop: 'giveAddressInfo.fullAddress',width: '180"',check: true,fixed: undefined},
        {label: '收货联系人',prop: 'giveAddressInfo.contactName',width: '70"',check: true,fixed: undefined},
        {label: '收货电话',prop: 'giveAddressInfo.contactPhone',width: '85"',check: true,fixed: undefined,formatter: 'maskMobileTable'},
        {label: '公里数(KM)',prop: 'orderInfo.distance',width: '80"',formatter: 'getDistanceValue',check: true,fixed: undefined},
        {label: '件数',prop: 'orderGoods.pieceNum',width: '40"',check: true,fixed: undefined},
        {label: '体积',prop: 'orderGoods.volume',width: '40"',check: true,fixed: undefined},
        {label: '重量',prop: 'orderGoods.weight',width: '40"',check: true,fixed: undefined},
        {label: '货物尺寸(长/宽/高)',prop: 'orderGoods.length',width: '110"',check: true,fixed: undefined},
        {label: '包装类型',prop: 'orderGoods.packType',width: '65',formatter: 'manyDictConvert',check: true,fixed: undefined},
        {label: '客户单号',prop: 'orderInfo.customerSelfNo',width: '70"',check: true,fixed: undefined},
        {label: '车次号',prop: 'vehiclePlan.planNo',width: '110',check: true,fixed: undefined},
        {label: '订单号',prop: 'orderInfo.orderNo',width: '105"',check: true,fixed: undefined},
        {label: '内部备注',prop: 'orderInfo.companyRemark',width: '60',check: true,fixed: undefined},
        {label: '下单时间',prop: 'orderInfo.commitTime',width: '120',check: true,fixed: undefined},
        {label: '调度时间',prop: 'orderInfo.dispatchTime',width: '120"',check: true,fixed: undefined},
        {label: '调度操作人',prop: 'orderInfo.dispatchName',width: '70"',check: true,fixed: undefined},
    ],
    configDefaultPropColumn: [],
    isConfigMode: false,
    configModeForm: {
        name: '',
        remark: '',
        defaultOrNot: '0'
    },
}

// 调度平台-订单管理-已出车
export const theVehicleHasBeenDispatched = {
    configId: null,
    configTableId: 12,
    configDefaultColumn: [
        {label: '客户名称',prop: 'orderInfo.customerName',width: '80',check: true,fixed: undefined},
        {label: '客户联系人',prop: 'orderInfo.customerContactName',width: '70',check: true,fixed: undefined},
        {label: '提货时间',prop: 'orderInfo.takeGoodsDate',width: '105',check: true,fixed: undefined},
        {label: '订单类型',prop: 'orderInfo.orderType',width: '60',formatter: 'orderType',check: true,fixed: undefined},
        {label: '所需车型',prop: 'orderInfo.vehicleType',width: '80',formatter: 'dictConvertVehicle',check: true,fixed: undefined},
        {label: '司机姓名',prop: 'vehiclePlan.driverName',width: '80',check: true,fixed: undefined},
        {label: '司机车牌',prop: 'vehiclePlan.vehiclePlate',width: '70',check: true,fixed: undefined},
        {label: '报关方式',prop: 'orderInfo.entranceType',width: '80',formatter: 'entranceType',check: true,fixed: undefined},
        {label: '提货方',prop: 'factoryName',width: '75',check: true,fixed: undefined},
        {label: '提货地址',prop: 'fullAddress',width: '150',check: true,fixed: undefined},
        {label: '提货联系人',prop: 'contactName',width: '70',check: true,fixed: undefined},
        {label: '提货联系人电话',prop: 'contactPhone',width: '85',check: true,fixed: undefined,formatter: 'maskMobileTable'},
        {label: '提货注意事项',prop: 'takeRemark',width: '85',check: true,fixed: undefined},
        {label: '卸货方',prop: 'giveAddressInfo.factoryName',width: '75"',check: true,fixed: undefined},
        {label: '收货地址',prop: 'giveAddressInfo.fullAddress',width: '180"',check: true,fixed: undefined},
        {label: '收货联系人',prop: 'giveAddressInfo.contactName',width: '70"',check: true,fixed: undefined},
        {label: '收货电话',prop: 'giveAddressInfo.contactPhone',width: '85"',check: true,fixed: undefined,formatter: 'maskMobileTable'},
        {label: '公里数(KM)',prop: 'orderInfo.distance',width: '180', formatter: 'getDistanceValue',check: true,fixed: undefined},
        {label: '件数',prop: 'orderGoods.pieceNum',width: '40"',check: true,fixed: undefined},
        {label: '体积',prop: 'orderGoods.volume',width: '40"',check: true,fixed: undefined},
        {label: '重量',prop: 'orderGoods.weight',width: '40"',check: true,fixed: undefined},
        {label: '货物尺寸(长/宽/高)',prop: 'orderGoods.length',width: '110"',check: true,fixed: undefined},
        {label: '包装类型',prop: 'orderGoods.packType',width: '65',formatter: 'manyDictConvert',check: true,fixed: undefined},
        {label: '客户单号',prop: 'orderInfo.customerSelfNo',width: '70"',check: true,fixed: undefined},
        {label: '车次号',prop: 'vehiclePlan.planNo',width: '110',check: true,fixed: undefined},
        {label: '订单号',prop: 'orderInfo.orderNo',width: '105"',check: true,fixed: undefined},
        {label: '下单时间',prop: 'orderInfo.commitTime',width: '120',check: true,fixed: undefined},
        {label: '调度时间',prop: 'orderInfo.dispatchTime',width: '120"',check: true,fixed: undefined},
        {label: '出车时间',prop: 'outDriveTime',width: '120"',check: true,fixed: undefined},
    ],
    configDefaultPropColumn: [],
    isConfigMode: false,
    configModeForm: {
        name: '',
        remark: '',
        defaultOrNot: '0'
    },
}

// 调度平台-订单管理-已到达
export const arrived = {
    configId: null,
    configTableId: 13,
    configDefaultColumn: [
        {label: '客户名称',prop: 'orderInfo.customerName',width: '80',check: true,fixed: undefined},
        {label: '客户联系人',prop: 'orderInfo.customerContactName',width: '70',check: true,fixed: undefined},
        {label: '提货时间',prop: 'orderInfo.takeGoodsDate',width: '105',check: true,fixed: undefined},
        {label: '订单类型',prop: 'orderInfo.orderType',width: '60',formatter: 'orderType',check: true,fixed: undefined},
        {label: '所需车型',prop: 'orderInfo.vehicleType',width: '80',formatter: 'dictConvertVehicle',check: true,fixed: undefined},
        {label: '司机姓名',prop: 'vehiclePlan.driverName',width: '80',check: true,fixed: undefined},
        {label: '司机车牌',prop: 'vehiclePlan.vehiclePlate',width: '70',check: true,fixed: undefined},
        {label: '报关方式',prop: 'orderInfo.entranceType',width: '80',formatter: 'entranceType',check: true,fixed: undefined},
        {label: '提货方',prop: 'factoryName',width: '75',check: true,fixed: undefined},
        {label: '提货地址',prop: 'fullAddress',width: '150',check: true,fixed: undefined},
        {label: '提货联系人',prop: 'contactName',width: '70',check: true,fixed: undefined},
        {label: '提货联系人电话',prop: 'contactPhone',width: '85',check: true,fixed: undefined,formatter: 'maskMobileTable'},
        {label: '提货注意事项',prop: 'takeRemark',width: '85',check: true,fixed: undefined},
        {label: '卸货方',prop: 'giveAddressInfo.factoryName',width: '75"',check: true,fixed: undefined},
        {label: '收货地址',prop: 'giveAddressInfo.fullAddress',width: '180"',check: true,fixed: undefined},
        {label: '收货联系人',prop: 'giveAddressInfo.contactName',width: '70"',check: true,fixed: undefined},
        {label: '收货电话',prop: 'giveAddressInfo.contactPhone',width: '85"',check: true,fixed: undefined,formatter: 'maskMobileTable'},
        {label: '公里数(KM)',prop: 'orderInfo.distance',width: '180', formatter: 'getDistanceValue',check: true,fixed: undefined},
        {label: '件数',prop: 'orderGoods.pieceNum',width: '40"',check: true,fixed: undefined},
        {label: '体积',prop: 'orderGoods.volume',width: '40"',check: true,fixed: undefined},
        {label: '重量',prop: 'orderGoods.weight',width: '40"',check: true,fixed: undefined},
        {label: '货物尺寸(长/宽/高)',prop: 'orderGoods.length',width: '110"',check: true,fixed: undefined},
        {label: '包装类型',prop: 'orderGoods.packType',width: '65',formatter: 'manyDictConvert',check: true,fixed: undefined},
        {label: '客户单号',prop: 'orderInfo.customerSelfNo',width: '70"',check: true,fixed: undefined},
        {label: '车次号',prop: 'vehiclePlan.planNo',width: '110',check: true,fixed: undefined},
        {label: '订单号',prop: 'orderInfo.orderNo',width: '105"',check: true,fixed: undefined},
        {label: '下单时间',prop: 'orderInfo.commitTime',width: '120',check: true,fixed: undefined},
        {label: '调度时间',prop: 'orderInfo.dispatchTime',width: '120"',check: true,fixed: undefined},
        {label: '调度操作人',prop: 'orderInfo.dispatchName',width: '70"',check: true,fixed: undefined},
        {label: '出车时间',prop: 'outDriveTime',width: '120"',check: true,fixed: undefined},
        {label: '到达时间',prop: 'arrivedTime',width: '120"',check: true,fixed: undefined},
    ],
    configDefaultPropColumn: [],
    isConfigMode: false,
    configModeForm: {
        name: '',
        remark: '',
        defaultOrNot: '0'
    },
}

// 调度平台-订单管理-已装货
export const loaded = {
    configId: null,
    configTableId: 14,
    configDefaultColumn: [
        {label: '客户名称',prop: 'orderInfo.customerName',width: '80',check: true,fixed: undefined},
        {label: '客户联系人',prop: 'orderInfo.customerContactName',width: '70',check: true,fixed: undefined},
        {label: '提货时间',prop: 'orderInfo.takeGoodsDate',width: '105',check: true,fixed: undefined},
        {label: '订单类型',prop: 'orderInfo.orderType',width: '60',formatter: 'orderType',check: true,fixed: undefined},
        {label: '所需车型',prop: 'orderInfo.vehicleType',width: '80',formatter: 'dictConvertVehicle',check: true,fixed: undefined},
        {label: '司机姓名',prop: 'vehiclePlan.driverName',width: '80',check: true,fixed: undefined},
        {label: '司机车牌',prop: 'vehiclePlan.vehiclePlate',width: '70',check: true,fixed: undefined},
        {label: '报关方式',prop: 'orderInfo.entranceType',width: '80',formatter: 'entranceType',check: true,fixed: undefined},
        {label: '提货方',prop: 'factoryName',width: '75',check: true,fixed: undefined},
        {label: '提货地址',prop: 'fullAddress',width: '150',check: true,fixed: undefined},
        {label: '提货联系人',prop: 'contactName',width: '70',check: true,fixed: undefined},
        {label: '提货联系人电话',prop: 'contactPhone',width: '85',check: true,fixed: undefined,formatter: 'maskMobileTable'},
        {label: '提货注意事项',prop: 'takeRemark',width: '85',check: true,fixed: undefined},
        {label: '卸货方',prop: 'giveAddressInfo.factoryName',width: '75"',check: true,fixed: undefined},
        {label: '收货地址',prop: 'giveAddressInfo.fullAddress',width: '180"',check: true,fixed: undefined},
        {label: '收货联系人',prop: 'giveAddressInfo.contactName',width: '70"',check: true,fixed: undefined},
        {label: '收货电话',prop: 'giveAddressInfo.contactPhone',width: '85"',check: true,fixed: undefined,formatter: 'maskMobileTable'},
        {label: '公里数(KM)',prop: 'orderInfo.distance',width: '180', formatter: 'getDistanceValue',check: true,fixed: undefined},
        {label: '件数',prop: 'orderGoods.pieceNum',width: '40"',check: true,fixed: undefined},
        {label: '体积',prop: 'orderGoods.volume',width: '40"',check: true,fixed: undefined},
        {label: '重量',prop: 'orderGoods.weight',width: '40"',check: true,fixed: undefined},
        {label: '货物尺寸(长/宽/高)',prop: 'orderGoods.length',width: '110"',check: true,fixed: undefined},
        {label: '包装类型',prop: 'orderGoods.packType',width: '65',formatter: 'manyDictConvert',check: true,fixed: undefined},
        {label: '客户单号',prop: 'orderInfo.customerSelfNo',width: '70"',check: true,fixed: undefined},
        {label: '车次号',prop: 'vehiclePlan.planNo',width: '110',check: true,fixed: undefined},
        {label: '订单号',prop: 'orderInfo.orderNo',width: '105"',check: true,fixed: undefined},
        {label: '下单时间',prop: 'orderInfo.commitTime',width: '120',check: true,fixed: undefined},
        {label: '调度时间',prop: 'orderInfo.dispatchTime',width: '120"',check: true,fixed: undefined},
        {label: '调度操作人',prop: 'orderInfo.dispatchName',width: '70"',check: true,fixed: undefined},
        {label: '出车时间',prop: 'outDriveTime',width: '120"',check: true,fixed: undefined},
        {label: '到达时间',prop: 'arrivedTime',width: '120"',check: true,fixed: undefined},
        {label: '装货完成时间',prop: 'loadGoodsTime',width: '120"',check: true,fixed: undefined},
        {label: '装货图片',prop: '装货图片',width: '70"',check: true,fixed: undefined},
    ],
    configDefaultPropColumn: [],
    isConfigMode: false,
    configModeForm: {
        name: '',
        remark: '',
        defaultOrNot: '0'
    },
}

// 调度平台-订单管理-卸货到场
export const arrivedGive = {
    configId: null,
    configTableId: 15,
    configDefaultColumn: [
        {label: '客户名称',prop: 'orderInfo.customerName',width: '80',check: true,fixed: undefined},
        {label: '客户联系人',prop: 'orderInfo.customerContactName',width: '70',check: true,fixed: undefined},
        {label: '提货时间',prop: 'orderInfo.takeGoodsDate',width: '105',check: true,fixed: undefined},
        {label: '订单类型',prop: 'orderInfo.orderType',width: '60',formatter: 'orderType',check: true,fixed: undefined},
        {label: '所需车型',prop: 'orderInfo.vehicleType',width: '80',formatter: 'dictConvertVehicle',check: true,fixed: undefined},
        {label: '司机姓名',prop: 'vehiclePlan.driverName',width: '80',check: true,fixed: undefined},
        {label: '司机车牌',prop: 'vehiclePlan.vehiclePlate',width: '70',check: true,fixed: undefined},
        {label: '报关方式',prop: 'orderInfo.entranceType',width: '80',formatter: 'entranceType',check: true,fixed: undefined},
        {label: '提货方',prop: 'factoryName',width: '75',check: true,fixed: undefined},
        {label: '提货地址',prop: 'fullAddress',width: '150',check: true,fixed: undefined},
        {label: '提货联系人',prop: 'contactName',width: '70',check: true,fixed: undefined},
        {label: '提货联系人电话',prop: 'contactPhone',width: '85',check: true,fixed: undefined,formatter: 'maskMobileTable'},
        {label: '提货注意事项',prop: 'takeRemark',width: '85',check: true,fixed: undefined},
        {label: '卸货方',prop: 'giveAddressInfo.factoryName',width: '75"',check: true,fixed: undefined},
        {label: '收货地址',prop: 'giveAddressInfo.fullAddress',width: '180"',check: true,fixed: undefined},
        {label: '收货联系人',prop: 'giveAddressInfo.contactName',width: '70"',check: true,fixed: undefined},
        {label: '收货电话',prop: 'giveAddressInfo.contactPhone',width: '85"',check: true,fixed: undefined,formatter: 'maskMobileTable'},
        {label: '公里数(KM)',prop: 'orderInfo.distance',width: '180', formatter: 'getDistanceValue',check: true,fixed: undefined},
        {label: '件数',prop: 'orderGoods.pieceNum',width: '40"',check: true,fixed: undefined},
        {label: '体积',prop: 'orderGoods.volume',width: '40"',check: true,fixed: undefined},
        {label: '重量',prop: 'orderGoods.weight',width: '40"',check: true,fixed: undefined},
        {label: '货物尺寸(长/宽/高)',prop: 'orderGoods.length',width: '110"',check: true,fixed: undefined},
        {label: '包装类型',prop: 'orderGoods.packType',width: '65',formatter: 'manyDictConvert',check: true,fixed: undefined},
        {label: '客户单号',prop: 'orderInfo.customerSelfNo',width: '70"',check: true,fixed: undefined},
        {label: '车次号',prop: 'vehiclePlan.planNo',width: '110',check: true,fixed: undefined},
        {label: '订单号',prop: 'orderInfo.orderNo',width: '105"',check: true,fixed: undefined},
        {label: '下单时间',prop: 'orderInfo.commitTime',width: '120',check: true,fixed: undefined},
        {label: '调度时间',prop: 'orderInfo.dispatchTime',width: '120"',check: true,fixed: undefined},
        {label: '调度操作人',prop: 'orderInfo.dispatchName',width: '70"',check: true,fixed: undefined},
        {label: '出车时间',prop: 'outDriveTimeOsr',width: '120"',check: true,fixed: undefined},
        {label: '到达时间',prop: 'arrivedTimeOsr',width: '120"',check: true,fixed: undefined},
        {label: '装货完成时间',prop: 'loadGoodsTimeOsr',width: '120"',check: true,fixed: undefined},
        {label: '装货图片',prop: '装货图片',width: '70"',check: true,fixed: undefined},
        {label: '卸货到达时间',prop: 'arrivedGiveTimeOsr',width: '120"',check: true,fixed: undefined},
        {label: '卸货到达地点',prop: 'arrivedGiveAddress',width: '120"',check: true,fixed: undefined},
    ],
    configDefaultPropColumn: [],
    isConfigMode: false,
    configModeForm: {
        name: '',
        remark: '',
        defaultOrNot: '0'
    },
}

// 调度平台-订单管理-已签收
export const signedFor = {
    configId: null,
    configTableId: 16,
    configDefaultColumn: [
        {label: '车次号',prop: 'vehiclePlan.planNo',width: '110',check: true,fixed: undefined},
        {label: '订单号',prop: 'orderInfo.orderNo',width: '105"',check: true,fixed: undefined},
        {label: '客户名称',prop: 'orderInfo.customerName',width: '80',check: true,fixed: undefined},
        {label: '客户联系人',prop: 'orderInfo.customerContactName',width: '70',check: true,fixed: undefined},
        {label: '提货时间',prop: 'orderInfo.takeGoodsDate',width: '105',check: true,fixed: undefined},
        {label: '订单类型',prop: 'orderInfo.orderType',width: '60',formatter: 'orderType',check: true,fixed: undefined},
        {label: '所需车型',prop: 'orderInfo.vehicleType',width: '80',formatter: 'dictConvertVehicle',check: true,fixed: undefined},
        {label: '指派车型',prop: 'vehiclePlan.vehicleTypeName',width: '80"',check: true,fixed: undefined},
        {label: '司机姓名',prop: 'vehiclePlan.driverName',width: '80',check: true,fixed: undefined},
        {label: '司机车牌',prop: 'vehiclePlan.vehiclePlate',width: '70',check: true,fixed: undefined},
        {label: '报关方式',prop: 'orderInfo.entranceType',width: '80',formatter: 'entranceType',check: true,fixed: undefined},
        {label: '提货方',prop: 'factoryName',width: '75',check: true,fixed: undefined},
        {label: '提货地址',prop: 'fullAddress',width: '150',check: true,fixed: undefined},
        {label: '提货联系人',prop: 'contactName',width: '70',check: true,fixed: undefined},
        {label: '提货联系人电话',prop: 'contactPhone',width: '85',check: true,fixed: undefined,formatter: 'maskMobileTable'},
        {label: '提货注意事项',prop: 'takeRemark',width: '85',check: true,fixed: undefined},
        {label: '卸货方',prop: 'giveAddressInfo.factoryName',width: '75"',check: true,fixed: undefined},
        {label: '收货地址',prop: 'giveAddressInfo.fullAddress',width: '180"',check: true,fixed: undefined},
        {label: '收货联系人',prop: 'giveAddressInfo.contactName',width: '70"',check: true,fixed: undefined},
        {label: '收货电话',prop: 'giveAddressInfo.contactPhone',width: '85"',check: true,fixed: undefined,formatter: 'maskMobileTable'},
        {label: '件数',prop: 'orderGoods.pieceNum',width: '40"',check: true,fixed: undefined},
        {label: '体积',prop: 'orderGoods.volume',width: '40"',check: true,fixed: undefined},
        {label: '重量',prop: 'orderGoods.weight',width: '40"',check: true,fixed: undefined},
        {label: '货物尺寸(长/宽/高)',prop: 'orderGoods.length',width: '110"',check: true,fixed: undefined},
        {label: '包装类型',prop: 'orderGoods.packType',width: '65',formatter: 'manyDictConvert',check: true,fixed: undefined},
        {label: '客户单号',prop: 'orderInfo.customerSelfNo',width: '70"',check: true,fixed: undefined},
        {label: '下单时间',prop: 'orderInfo.commitTime',width: '120',check: true,fixed: undefined},
        {label: '调度时间',prop: 'orderInfo.dispatchTime',width: '120"',check: true,fixed: undefined},
        {label: '调度操作人',prop: 'orderInfo.dispatchName',width: '70"',check: true,fixed: undefined},
        {label: '派车时间',prop: 'orderInfo.dispatchTime',width: '120"',check: true,fixed: undefined},
        {label: '出车时间',prop: 'outDriveTimeOsr',width: '120"',check: true,fixed: undefined},
        {label: '装货到场时间',prop: 'arrivedTimeOsr',width: '120"',check: true,fixed: undefined},
        {label: '装货离场时间',prop: 'loadGoodsTimeOsr',width: '120"',check: true,fixed: undefined},
        {label: '卸货到场时间',prop: 'arrivedGiveTimeOsr',width: '120"',check: true,fixed: undefined},
        {label: '签收时间',prop: 'orderInfo.successTime',width: '120"',check: true,fixed: undefined},
        {label: '装货图片',prop: '装货图片',width: '70"',check: true,fixed: undefined},
        {label: '签收图片',prop: '签收图片',width: '70"',check: true,fixed: undefined},
    ],
    configDefaultPropColumn: [],
    isConfigMode: false,
    configModeForm: {
        name: '',
        remark: '',
        defaultOrNot: '0'
    },
}

// 订单平台-订单列表(客户)
export const orderListCustomer = {
    configId: null,
    configTableId: 3,
    configDefaultColumn: [
        {label: '客户名称',prop: 'orderInfo.customerName',width: '100',check: true,fixed: undefined},
        {label: '客户联系人',prop: 'orderInfo.customerContactName',width: '70',check: true,fixed: undefined},
        {label: '提货时间',prop: 'deliveryTimeNode',width: '105',check: true,fixed: undefined},
        {label: '进仓单号',prop: 'orderInfo.inWarehouseNo',width: '70',check: true,fixed: undefined},
        {label: '订单类型',prop: 'orderInfo.orderType',width: '60',formatter: 'orderType',check: true,fixed: undefined},
        {label: '所需车型',prop: 'orderInfo.vehicleType',width: '75',formatter: 'dictConvertVehicle',check: true,fixed: undefined},
        {label: '司机车牌',prop: 'vehiclePlan.vehiclePlate',width: '70',check: true,fixed: undefined},
        {label: '报关方式',prop: 'orderInfo.entranceType',width: '75',formatter: 'entranceType',check: true,fixed: undefined},
        {label: '提货方',prop: 'factoryName',width: '80',check: true,fixed: undefined},
        {label: '提货地址',prop: 'fullAddress',width: '180',check: true,fixed: undefined},
        {label: '提货联系人',prop: 'contactName',width: '70',check: true,fixed: undefined},
        {label: '提货电话',prop: 'contactPhone',width: '85',check: true,fixed: undefined,formatter: 'maskMobileTable'},
        {label: '卸货方',prop: 'giveAddressInfo.factoryName',width: '75"',check: true,fixed: undefined},
        {label: '收货地址',prop: 'giveAddressInfo.fullAddress',width: '180"',check: true,fixed: undefined},
        {label: '收货联系人',prop: 'giveAddressInfo.contactName',width: '70"',check: true,fixed: undefined},
        {label: '收货电话',prop: 'giveAddressInfo.contactPhone',width: '85"',check: true,fixed: undefined,formatter: 'maskMobileTable'},
        {label: '件数',prop: 'orderGoods.pieceNum',width: '40"',check: true,fixed: undefined},
        {label: '体积',prop: 'orderGoods.volume',width: '40"',check: true,fixed: undefined},
        {label: '重量',prop: 'orderGoods.weight',width: '40"',check: true,fixed: undefined},
        {label: '货物尺寸(长/宽/高)',prop: 'orderGoods.length',width: '110"',check: true,fixed: undefined},
        {label: '包装类型',prop: 'orderGoods.packType',width: '80',formatter: 'manyDictConvert',check: true,fixed: undefined},
        {label: '异常备注',prop: 'orderInfo.groupExplain',width: '80"',check: true,fixed: undefined},
        {label: '车辆空重(kg)',prop: 'vehiclePlan.vehicleEmptyWeight',width: '95"',check: true,fixed: undefined},
        {label: '司机姓名',prop: 'vehiclePlan.driverName',width: '60"',check: true,fixed: undefined},
        {label: '司机电话',prop: 'vehiclePlan.driverPhone',width: '85"',check: true,fixed: undefined,formatter: 'maskMobileTable'},
        {label: '身份证号',prop: 'vehiclePlan.driverCard',width: '130"',check: true,fixed: undefined},
        {label: '是否尾板',prop: 'orderInfo.isTailstock',width: '70"',formatter: 'yesNo',check: true,fixed: undefined},
        {label: '订单号',prop: 'orderInfo.orderNo',width: '105"',check: true,fixed: undefined},
        {label: '客户单号',prop: 'orderInfo.customerSelfNo',width: '70"',check: true,fixed: undefined},
        {label: '客户联系电话',prop: 'orderInfo.customerContactPhone',width: '90"',check: true,fixed: undefined,formatter: 'maskMobileTable'},
        {label: '装货图片',prop: '装货图片',width: '70"',check: true,fixed: undefined},
        {label: '签收图片',prop: '签收图片',width: '70"',check: true,fixed: undefined},
        {label: '下单时间',prop: 'orderInfo.commitTime',width: '120"',check: true,fixed: undefined},
        {label: '下单人',prop: 'orderInfo.commitName',width: '70"',check: true,fixed: undefined},
        {label: '派车时间',prop: 'orderInfo.dispatchTime',width: '120"',check: true,fixed: undefined},
        {label: '出车时间',prop: 'outDriveTimeOsr',width: '120"',check: true,fixed: undefined},
        {label: '装货到场时间',prop: 'arrivedTimeOsr',width: '120"',check: true,fixed: undefined},
        {label: '装货离场时间',prop: 'loadGoodsTimeOsr',width: '120"',check: true,fixed: undefined},
        {label: '卸货到场时间',prop: 'arrivedGiveTimeOsr',width: '120"',check: true,fixed: undefined},
        {label: '签收时间',prop: 'orderInfo.successTime',width: '120"',check: true,fixed: undefined},
        {label: '状态',prop: 'status',fixed: 'right',width: '58"',check: true},
        {label: '报出状态',prop: 'orderInfo.entranceOutStatus',fixed: 'right',width: '60"',check: true},
        {label: '报出时间',prop: 'orderInfo.clickOutTime',fixed: 'right',width: '85"',check: true},
        {label: '报入状态',prop: 'orderInfo.entranceInStatus',fixed: 'right',width: '60"',check: true},
        {label: '报入时间',prop: 'orderInfo.clickInTime',fixed: 'right',width: '70"',check: true},
    ],
    configDefaultPropColumn: [],
    isConfigMode: false,
    configModeForm: {
        name: '',
        remark: '',
        defaultOrNot: '0'
    },
}

// 调度平台-订单管理-全部
export const orderAll = {
    configId: null,
    configTableId: 5,
    configDefaultColumn: [
        {label: '订单号',prop: 'orderInfo.orderNo',width: '105"',check: true,fixed: undefined},
        {label: '客户名称',prop: 'orderInfo.customerName',width: '70',check: true,fixed: undefined},
        {label: '提货时间',prop: 'orderInfo.takeGoodsDate',width: '105',check: true,fixed: undefined},
        {label: '订单类型',prop: 'orderInfo.orderType',width: '60',formatter: 'orderType',check: true,fixed: undefined},
        {label: '所需车型',prop: 'orderInfo.vehicleType',width: '80',formatter: 'dictConvertVehicle',check: true,fixed: undefined},
        {label: '报关方式',prop: 'orderInfo.entranceType',width: '80',formatter: 'entranceType',check: true,fixed: undefined},
        {label: '提货方',prop: 'factoryName',width: '75',check: true,fixed: undefined},
        {label: '提货地址',prop: 'fullAddress',width: '180',check: true,fixed: undefined},
        {label: '提货联系人',prop: 'contactName',width: '70',check: true,fixed: undefined},
        {label: '提货联系人电话',prop: 'contactPhone',width: '85',check: true,fixed: undefined,formatter: 'maskMobileTable'},
        {label: '提货注意事项',prop: 'takeRemark',width: '85',check: true,fixed: undefined},
        {label: '卸货方',prop: 'giveAddressInfo.factoryName',width: '75"',check: true,fixed: undefined},
        {label: '收货地址',prop: 'giveAddressInfo.fullAddress',width: '180"',check: true,fixed: undefined},
        {label: '收货联系人',prop: 'giveAddressInfo.contactName',width: '70"',check: true,fixed: undefined},
        {label: '收货电话',prop: 'giveAddressInfo.contactPhone',width: '90"',check: true,fixed: undefined,formatter: 'maskMobileTable'},
        {label: '件数',prop: 'orderGoods.pieceNum',width: '40"',check: true,fixed: undefined},
        {label: '体积',prop: 'orderGoods.volume',width: '40"',check: true,fixed: undefined},
        {label: '重量',prop: 'orderGoods.weight',width: '40"',check: true,fixed: undefined},
        {label: '货物尺寸(长/宽/高)',prop: 'orderGoods.length',width: '110"',check: true,fixed: undefined},
        {label: '包装类型',prop: 'orderGoods.packType',width: '80',formatter: 'manyDictConvert',check: true,fixed: undefined},
        {label: '客户单号',prop: 'orderInfo.customerSelfNo',width: '70"',check: true,fixed: undefined},
        {label: '下单时间',prop: 'orderInfo.commitTime',width: '120"',check: true,fixed: undefined},
        {label: '内部备注',prop: 'orderInfo.companyRemark',width: '100"',check: true,fixed: undefined},
        {label: '状态',prop: 'status',fixed: 'right',width: '50"',check: true},
    ],
    configDefaultPropColumn: [],
    isConfigMode: false,
    configModeForm: {
        name: '',
        remark: '',
        defaultOrNot: '0'
    },
}

// 调度平台-订单管理-分拨中心
export const allocatedCenter = {
    configId: null,
    configTableId: 6,
    configDefaultColumn: [
        {label: '分享',prop: 'driverBusinessCardSharingWechat',fixed: 'left',width: '40',check: true},
        {label: '进仓单号',prop: 'orderInfo.inWarehouseNo',width: '105"',check: true,fixed: undefined},
        {label: '客户名称',prop: 'orderInfo.customerName',width: '60',check: true,fixed: undefined},
        {label: '提货时间',prop: 'orderInfo.takeGoodsDate',width: '105',check: true,fixed: undefined},
        {label: '订单类型',prop: 'orderInfo.orderType',width: '35',formatter: 'orderType',check: true,fixed: undefined},
        {label: '所需车型',prop: 'orderInfo.vehicleType',width: '80',formatter: 'dictConvertVehicle',check: true,fixed: undefined},
        {label: '报关方式',prop: 'orderInfo.entranceType',width: '80',formatter: 'entranceType',check: true,fixed: undefined},
        {label: '提货方',prop: 'factoryName',width: '75',check: true,fixed: undefined},
        {label: '提货地址',prop: 'fullAddress',width: '150',check: true,fixed: undefined},
        {label: '卸货方',prop: 'giveAddressInfo.factoryName',width: '75"',check: true,fixed: undefined},
        {label: '收货地址',prop: 'giveAddressInfo.fullAddress',width: '150"',check: true,fixed: undefined},
        {label: '公里数(KM)',prop: 'orderInfo.distance',width: '80"',formatter: 'getDistanceValue',check: true,fixed: undefined},
        {label: '件数',prop: 'orderGoods.pieceNum',width: '40"',check: true,fixed: undefined},
        {label: '体积',prop: 'orderGoods.volume',width: '40"',check: true,fixed: undefined},
        {label: '重量',prop: 'orderGoods.weight',width: '40"',check: true,fixed: undefined},
        {label: '货物尺寸(长/宽/高)',prop: 'orderGoods.length',width: '110"',check: true,fixed: undefined},
        {label: '包装类型',prop: 'orderGoods.packType',width: '65',formatter: 'manyDictConvert',check: true,fixed: undefined},
        {label: '货物备注',prop: 'orderGoods.remark',fixed: 'right',width: '85"',check: true},
        {label: '带尾板',prop: 'orderInfo.isTailstock',width: '45',formatter: 'yesNo',check: true,fixed: undefined},
        {label: '提货联系人',prop: 'contactName',width: '70',check: true,fixed: undefined},
        {label: '提货联系人电话',prop: 'contactPhone',width: '85',check: true,fixed: undefined,formatter: 'maskMobileTable'},
        {label: '收货联系人',prop: 'giveAddressInfo.contactName',width: '70"',check: true,fixed: undefined},
        {label: '收货电话',prop: 'giveAddressInfo.contactPhone',width: '85"',check: true,fixed: undefined,formatter: 'maskMobileTable'},
        {label: '客户单号',prop: 'orderInfo.customerSelfNo',width: '70"',check: true,fixed: undefined},
        {label: '下单时间',prop: 'orderInfo.commitTime',width: '120"',check: true,fixed: undefined},
        {label: '订单号',prop: 'orderInfo.orderNo',width: '105"',check: true,fixed: undefined},
    ],
    configDefaultPropColumn: [],
    isConfigMode: false,
    configModeForm: {
        name: '',
        remark: '',
        defaultOrNot: '0'
    },
}

// 调度平台-订单管理-指派中
export const scheduleding = {
    configId: null,
    configTableId: 7,
    configDefaultColumn: [
        {label: '分享',prop: 'driverBusinessCardSharingWechat',fixed: 'left',width: '40',check: true},
        {label: '状态',prop: '状态',width: '50"',check: true,fixed: 'left'},
        {label: '进仓单号',prop: 'orderInfo.inWarehouseNo',width: '105"',check: true,fixed: undefined},
        {label: '客户名称',prop: 'orderInfo.customerName',width: '60',check: true,fixed: undefined},
        {label: '提货时间',prop: 'orderInfo.takeGoodsDate',width: '105',check: true,fixed: undefined},
        {label: '订单类型',prop: 'orderInfo.orderType',width: '35',formatter: 'orderType',check: true,fixed: undefined},
        {label: '所需车型',prop: 'orderInfo.vehicleType',width: '80',formatter: 'dictConvertVehicle',check: true,fixed: undefined},
        {label: '报关方式',prop: 'orderInfo.entranceType',width: '80',formatter: 'entranceType',check: true,fixed: undefined},
        {label: '提货方',prop: 'factoryName',width: '75',check: true,fixed: undefined},
        {label: '提货地址',prop: 'fullAddress',width: '150',check: true,fixed: undefined},
        {label: '卸货方',prop: 'giveAddressInfo.factoryName',width: '75"',check: true,fixed: undefined},
        {label: '收货地址',prop: 'giveAddressInfo.fullAddress',width: '150"',check: true,fixed: undefined},
        {label: '公里数(KM)',prop: 'orderInfo.distance',width: '80"',formatter: 'getDistanceValue',check: true,fixed: undefined},
        {label: '件数',prop: 'orderGoods.pieceNum',width: '40"',check: true,fixed: undefined},
        {label: '体积',prop: 'orderGoods.volume',width: '40"',check: true,fixed: undefined},
        {label: '重量',prop: 'orderGoods.weight',width: '40"',check: true,fixed: undefined},
        {label: '货物尺寸(长/宽/高)',prop: 'orderGoods.length',width: '110"',check: true,fixed: undefined},
        {label: '包装类型',prop: 'orderGoods.packType',width: '65',formatter: 'manyDictConvert',check: true,fixed: undefined},
        {label: '货物备注',prop: 'orderGoods.remark',fixed: 'right',width: '85"',check: true},
        {label: '带尾板',prop: 'orderInfo.isTailstock',width: '45',formatter: 'yesNo',check: true,fixed: undefined},
        {label: '提货联系人',prop: 'contactName',width: '70',check: true,fixed: undefined},
        {label: '提货联系人电话',prop: 'contactPhone',width: '85',check: true,fixed: undefined,formatter: 'maskMobileTable'},
        {label: '收货联系人',prop: 'giveAddressInfo.contactName',width: '70"',check: true,fixed: undefined},
        {label: '收货电话',prop: 'giveAddressInfo.contactPhone',width: '85"',check: true,fixed: undefined,formatter: 'maskMobileTable'},
        {label: '指派车型',prop: 'vehiclePlan.vehicleTypeName',width: '80"',check: true,fixed: undefined},
        {label: '车牌号',prop: 'vehiclePlan.vehiclePlate',width: '70"',check: true,fixed: undefined},
        {label: '客户单号',prop: 'orderInfo.customerSelfNo',width: '70"',check: true,fixed: undefined},
        {label: '内部备注',prop: 'orderInfo.companyRemark',width: '100"',check: true,fixed: undefined},
        {label: '下单时间',prop: 'orderInfo.commitTime',width: '120"',check: true,fixed: undefined},
        {label: '订单号',prop: 'orderInfo.orderNo',width: '105"',check: true,fixed: undefined},
    ],
    configDefaultPropColumn: [],
    isConfigMode: false,
    configModeForm: {
        name: '',
        remark: '',
        defaultOrNot: '0'
    },
}

// 调度平台-订单管理-报价中
export const offerCenter = {
    configId: null,
    configTableId: 8,
    configDefaultColumn: [
        {label: '分享',prop: 'driverBusinessCardSharingWechat',fixed: 'left',width: '40',check: true},
        {label: '订单号',prop: 'orderInfo.orderNo',width: '105"',check: true,fixed: undefined},
        {label: '进仓单号',prop: 'orderInfo.inWarehouseNo',width: '110"',check: true,fixed: undefined},
        {label: '客户名称',prop: 'orderInfo.customerName',width: '80',check: true,fixed: undefined},
        {label: '提货时间',prop: 'orderInfo.takeGoodsDate',width: '105',check: true,fixed: undefined},
        {label: '分拨时间',prop: 'orderInfo.allocatedTime',width: '105',check: true,fixed: undefined},
        {label: '报价截止时间',prop: 'orderInfo.deadlineTime',width: '105',check: true,fixed: undefined},
        {label: '参与人数"',prop: 'orderInfo.joinNumber',width: '60',check: true,fixed: undefined},
        {label: '最新底价"',prop: 'orderInfo.newPrice',width: '60',check: true,fixed: undefined},
        {label: '理想价格"',prop: 'orderInfo.settingPrice',width: '60',check: true,fixed: undefined},
        {label: '报价状态',prop: 'orderInfo.modeStatus',width: '70',check: true,fixed: undefined},
        {label: '所需车型',prop: 'orderInfo.vehicleType',width: '80',formatter: 'dictConvertVehicle',check: true,fixed: undefined},
        {label: '订单类型',prop: 'orderInfo.orderType',width: '35',formatter: 'orderType',check: true,fixed: undefined},
        {label: '报关方式',prop: 'orderInfo.entranceType',width: '80',formatter: 'entranceType',check: true,fixed: undefined},
        {label: '提货方',prop: 'factoryName',width: '75',check: true,fixed: undefined},
        {label: '提货地址',prop: 'fullAddress',width: '150',check: true,fixed: undefined},
        {label: '提货联系人',prop: 'contactName',width: '70',check: true,fixed: undefined},
        {label: '提货联系人电话',prop: 'contactPhone',width: '85',check: true,fixed: undefined,formatter: 'maskMobileTable'},
        {label: '卸货方',prop: 'giveAddressInfo.factoryName',width: '75"',check: true,fixed: undefined},
        {label: '收货地址',prop: 'giveAddressInfo.fullAddress',width: '150"',check: true,fixed: undefined},
        {label: '件数',prop: 'orderGoods.pieceNum',width: '40"',check: true,fixed: undefined},
        {label: '体积',prop: 'orderGoods.volume',width: '40"',check: true,fixed: undefined},
        {label: '重量',prop: 'orderGoods.weight',width: '40"',check: true,fixed: undefined},
        {label: '货物尺寸(长/宽/高)',prop: 'orderGoods.length',width: '110"',check: true,fixed: undefined},
        {label: '包装类型',prop: 'orderGoods.packType',width: '65',formatter: 'manyDictConvert',check: true,fixed: undefined},
        {label: '收货联系人',prop: 'giveAddressInfo.contactName',width: '70"',check: true,fixed: undefined},
        {label: '收货电话',prop: 'giveAddressInfo.contactPhone',width: '85"',check: true,fixed: undefined,formatter: 'maskMobileTable'},
    ],
    configDefaultPropColumn: [],
    isConfigMode: false,
    configModeForm: {
        name: '',
        remark: '',
        defaultOrNot: '0'
    },
}

// 调度平台-订单管理-抢单中
export const grabCenter = {
    configId: null,
    configTableId: 9,
    configDefaultColumn: [
        {label: '分享',prop: 'driverBusinessCardSharingWechat',fixed: 'left',width: '40',check: true},
        {label: '订单号',prop: 'orderInfo.orderNo',width: '105"',check: true,fixed: undefined},
        {label: '进仓单号',prop: 'orderInfo.inWarehouseNo',width: '110"',check: true,fixed: undefined},
        {label: '客户名称',prop: 'orderInfo.customerName',width: '80',check: true,fixed: undefined},
        {label: '提货时间',prop: 'orderInfo.takeGoodsDate',width: '105',check: true,fixed: undefined},
        {label: '分拨时间',prop: 'orderInfo.allocatedTime',width: '105',check: true,fixed: undefined},
        {label: '抢单截止时间',prop: 'orderInfo.deadlineTime',width: '105',check: true,fixed: undefined},
        {label: '抢单状态',prop: 'orderInfo.modeStatus',width: '70',check: true,fixed: undefined},
        {label: '平台运费价',prop: 'orderInfo.newPrice',width: '60',check: true,fixed: undefined},
        {label: '设置价格',prop: 'orderInfo.settingPrice',width: '60',check: true,fixed: undefined},
        {label: '订单车型',prop: 'orderInfo.vehicleType',width: '80',formatter: 'dictConvert',check: true,fixed: undefined},
        {label: '报关方式',prop: 'orderInfo.entranceType',width: '80',formatter: 'entranceType',check: true,fixed: undefined},
        {label: '提货方',prop: 'factoryName',width: '75',check: true,fixed: undefined},
        {label: '提货地址',prop: 'fullAddress',width: '150',check: true,fixed: undefined},
        {label: '提货联系人',prop: 'contactName',width: '70',check: true,fixed: undefined},
        {label: '提货联系人电话',prop: 'contactPhone',width: '85',check: true,fixed: undefined,formatter: 'maskMobileTable'},
        {label: '卸货方',prop: 'giveAddressInfo.factoryName',width: '75"',check: true,fixed: undefined},
        {label: '收货地址',prop: 'giveAddressInfo.fullAddress',width: '150"',check: true,fixed: undefined},
        {label: '件数',prop: 'orderGoods.pieceNum',width: '40"',check: true,fixed: undefined},
        {label: '体积',prop: 'orderGoods.volume',width: '40"',check: true,fixed: undefined},
        {label: '重量',prop: 'orderGoods.weight',width: '40"',check: true,fixed: undefined},
        {label: '货物尺寸(长/宽/高)',prop: 'orderGoods.length',width: '110"',check: true,fixed: undefined},
        {label: '包装类型',prop: 'orderGoods.packType',width: '65',formatter: 'manyDictConvert',check: true,fixed: undefined},
        {label: '收货联系人',prop: 'giveAddressInfo.contactName',width: '70"',check: true,fixed: undefined},
        {label: '收货电话',prop: 'giveAddressInfo.contactPhone',width: '85"',check: true,fixed: undefined,formatter: 'maskMobileTable'},
    ],
    configDefaultPropColumn: [],
    isConfigMode: false,
    configModeForm: {
        name: '',
        remark: '',
        defaultOrNot: '0'
    },
}

// 调度平台-订单管理-已拒单
export const refuseOrder = {
    configId: null,
    configTableId: 11,
    configDefaultColumn: [
        {label: '客户名称',prop: 'orderInfo.customerName',width: '80',check: true,fixed: undefined},
        {label: '客户联系人',prop: 'orderInfo.customerContactName',width: '70',check: true,fixed: undefined},
        {label: '提货时间',prop: 'orderInfo.takeGoodsDate',width: '105',check: true,fixed: undefined},
        {label: '订单类型',prop: 'orderInfo.orderType',width: '60',formatter: 'orderType',check: true,fixed: undefined},
        {label: '所需车型',prop: 'orderInfo.vehicleType',width: '80',formatter: 'dictConvertVehicle',check: true,fixed: undefined},
        {label: '车牌号',prop: 'vehiclePlan.vehiclePlate',width: '70',check: true,fixed: undefined},
        {label: '报关方式',prop: 'orderInfo.entranceType',width: '80',formatter: 'entranceType',check: true,fixed: undefined},
        {label: '提货方',prop: 'factoryName',width: '75',check: true,fixed: undefined},
        {label: '提货地址',prop: 'fullAddress',width: '150',check: true,fixed: undefined},
        {label: '提货联系人',prop: 'contactName',width: '70',check: true,fixed: undefined},
        {label: '提货联系人电话',prop: 'contactPhone',width: '85',check: true,fixed: undefined,formatter: 'maskMobileTable'},
        {label: '提货注意事项',prop: 'takeRemark',width: '85',check: true,fixed: undefined},
        {label: '卸货方',prop: 'giveAddressInfo.factoryName',width: '75"',check: true,fixed: undefined},
        {label: '收货地址',prop: 'giveAddressInfo.fullAddress',width: '180"',check: true,fixed: undefined},
        {label: '收货联系人',prop: 'giveAddressInfo.contactName',width: '70"',check: true,fixed: undefined},
        {label: '收货电话',prop: 'giveAddressInfo.contactPhone',width: '85"',check: true,fixed: undefined,formatter: 'maskMobileTable'},
        {label: '件数',prop: 'orderGoods.pieceNum',width: '40"',check: true,fixed: undefined},
        {label: '体积',prop: 'orderGoods.volume',width: '40"',check: true,fixed: undefined},
        {label: '重量',prop: 'orderGoods.weight',width: '40"',check: true,fixed: undefined},
        {label: '货物尺寸(长/宽/高)',prop: 'orderGoods.length',width: '110"',check: true,fixed: undefined},
        {label: '包装类型',prop: 'orderGoods.packType',width: '65',formatter: 'manyDictConvert',check: true,fixed: undefined},
        {label: '客户单号',prop: 'orderInfo.customerSelfNo',width: '70"',check: true,fixed: undefined},
        {label: '车次号',prop: 'vehiclePlan.planNo',width: '110',check: true,fixed: undefined},
        {label: '订单号',prop: 'orderInfo.orderNo',width: '105"',check: true,fixed: undefined},
        {label: '内部备注',prop: 'orderInfo.companyRemark',width: '60',check: true,fixed: undefined},
        {label: '下单时间',prop: 'orderInfo.commitTime',width: '120',check: true,fixed: undefined},
        {label: '调度时间',prop: 'orderInfo.dispatchTime',width: '120"',check: true,fixed: undefined},
        {label: '调度操作人',prop: 'orderInfo.dispatchName',width: '70"',check: true,fixed: undefined},
        {label: '拒绝时间',prop: 'orderInfo.refuseTime',width: '120"',check: true,fixed: undefined},
        {label: '拒绝原因',prop: 'orderInfo.refuseDesc',width: '120"',check: true,fixed: undefined},
    ],
    configDefaultPropColumn: [],
    isConfigMode: false,
    configModeForm: {
        name: '',
        remark: '',
        defaultOrNot: '0'
    },
}

// 调度平台-订单管理-订单退回
export const orderReturn = {
    configId: null,
    configTableId: 17,
    configDefaultColumn: [
        {label: '订单号',prop: 'orderInfo.orderNo',width: '105"',check: true,fixed: undefined},
        {label: '客户名称',prop: 'orderInfo.customerName',width: '80',check: true,fixed: undefined},
        {label: '提货时间',prop: 'orderInfo.takeGoodsDate',width: '105',check: true,fixed: undefined},
        {label: '订单类型',prop: 'orderInfo.orderType',width: '60',formatter: 'orderType',check: true,fixed: undefined},
        {label: '所需车型',prop: 'orderInfo.vehicleType',width: '80',formatter: 'dictConvertVehicle',check: true,fixed: undefined},
        {label: '指派车型',prop: 'vehiclePlan.vehicleTypeName',width: '80"',check: true,fixed: undefined},
        {label: '车牌号',prop: 'vehiclePlan.vehiclePlate',width: '70',check: true,fixed: undefined},
        {label: '报关方式',prop: 'orderInfo.entranceType',width: '80',formatter: 'entranceType',check: true,fixed: undefined},
        {label: '提货方',prop: 'factoryName',width: '75',check: true,fixed: undefined},
        {label: '提货地址',prop: 'fullAddress',width: '150',check: true,fixed: undefined},
        {label: '提货联系人',prop: 'contactName',width: '70',check: true,fixed: undefined},
        {label: '提货联系人电话',prop: 'contactPhone',width: '85',check: true,fixed: undefined,formatter: 'maskMobileTable'},
        {label: '提货注意事项',prop: 'takeRemark',width: '85',check: true,fixed: undefined},
        {label: '卸货方',prop: 'giveAddressInfo.factoryName',width: '75"',check: true,fixed: undefined},
        {label: '收货地址',prop: 'giveAddressInfo.fullAddress',width: '180"',check: true,fixed: undefined},
        {label: '收货联系人',prop: 'giveAddressInfo.contactName',width: '70"',check: true,fixed: undefined},
        {label: '收货电话',prop: 'giveAddressInfo.contactPhone',width: '85"',check: true,fixed: undefined,formatter: 'maskMobileTable'},
        {label: '件数',prop: 'orderGoods.pieceNum',width: '40"',check: true,fixed: undefined},
        {label: '体积',prop: 'orderGoods.volume',width: '40"',check: true,fixed: undefined},
        {label: '重量',prop: 'orderGoods.weight',width: '40"',check: true,fixed: undefined},
        {label: '货物尺寸(长/宽/高)',prop: 'orderGoods.length',width: '110"',check: true,fixed: undefined},
        {label: '包装类型',prop: 'orderGoods.packType',width: '65',formatter: 'manyDictConvert',check: true,fixed: undefined},
        {label: '客户单号',prop: 'orderInfo.customerSelfNo',width: '70"',check: true,fixed: undefined},
        {label: '下单时间',prop: 'orderInfo.commitTime',width: '120',check: true,fixed: undefined},
        {label: '退回时间',prop: 'orderInfo.returnTime',width: '120',check: true,fixed: undefined},
        {label: '退回操作人',prop: 'orderInfo.returnName',width: '70',check: true,fixed: undefined},
    ],
    configDefaultPropColumn: [],
    isConfigMode: false,
    configModeForm: {
        name: '',
        remark: '',
        defaultOrNot: '0'
    },
}

// 费用管理-订单费用核对
export const orderCost = {
    configId: null,
    configTableId: 1,
    configDefaultColumn: [
        {label: '提货时间',prop: 'deliveryTimeNode',fixed: 'left',width: '105',check: true},
        {label: '客户名称',prop: 'customerNameNode',fixed: 'left',width: '70',check: true},
        {label: '司机车牌',prop: 'vehiclePlateNode',fixed: 'left',width: '70',check: true},
        {label: '进仓单号',prop: 'inWarehouseNoNode',width: '80',check: true,fixed: undefined},
        {label: '订单类型',prop: 'orderTypeNode',width: '60',formatter: 'orderType',check: true,fixed: undefined},
        {label: '订单车型',prop: 'vehicleTypeNode',width: '60',formatter: 'dictConvertVehicle',check: true,fixed: undefined},
        {label: '报关方式',prop: 'entranceTypeNode',width: '80',formatter: 'entranceType',check: true,fixed: undefined},
        {label: '提货方',prop: 'factoryName',width: '100',check: true,fixed: undefined},
        {label: '提货地址',prop: 'fullAddress',width: '180',check: true,fixed: undefined},
        {label: '收货方',prop: 'factoryNameNode',width: '100',check: true,fixed: undefined},
        {label: '收货地址',prop: 'fullAddressNode',width: '180',check: true,fixed: undefined},
        {label: '公里数(KM)',prop: 'orderInfo.distance',width: '180', formatter: 'getDistanceValue',check: true,fixed: undefined},
        {label: '费用小计',prop: 'costInfo.totalMoney',width: '80',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v3'},
        {label: '运费',prop: 'costInfo.freightFee',width: '70',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v3'},
        {label: '报关/入仓费',prop: 'costInfo.entranceFee',width: '75',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v3'},
        {label: '高速费',prop: 'costInfo.highFee',width: '50',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v3'},
        {label: '过磅费',prop: 'costInfo.weighFee',width: '50',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v3'},
        {label: '装卸费',prop: 'costInfo.loadFee',width: '50',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v3'},
        {label: '押夜/超时费',prop: 'costInfo.overtimeFee',width: '70',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v3'},
        {label: '提货费',prop: 'costInfo.takeFee',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v3'},
        {label: '加点费',prop: 'costInfo.addFee',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v3'},
        {label: '停车费',prop: 'costInfo.parkingFee',width: '50',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v3'},
        {label: '其他费用',prop: 'costInfo.otherFee',width: '55',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v3'},
        {label: '其他费用备注',prop: 'costInfo.otherFeeRemark',check: true,fixed: undefined,styleClass: 'my-table-cell-v3'},
        {label: '异常说明',prop: 'groupExplain',width: '60',check: true,fixed: undefined},
        {label: '费用小计',prop: 'payCostInfo.auditTotalMoney',width: '80',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell'},
        {label: '运费',prop: 'payCostInfo.freightFee',width: '60',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell'},
        {label: '报关/入仓费',prop: 'payCostInfo.entranceFee',width: '75',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell'},
        {label: '高速费',prop: 'payCostInfo.highFee',width: '50',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell'},
        {label: '过磅费',prop: 'payCostInfo.weighFee',width: '50',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell'},
        {label: '装卸费',prop: 'payCostInfo.loadFee',width: '50',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell'},
        {label: '押夜/超时费',prop: 'payCostInfo.overtimeFee',width: '70',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell'},
        {label: '提货费',prop: 'payCostInfo.takeFee',width: '50',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell'},
        {label: '加点费',prop: 'payCostInfo.addFee',width: '50',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell'},
        {label: '停车费',prop: 'payCostInfo.parkingFee',width: '50',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell'},
        {label: '打印费用',prop: 'payCostInfo.printFee',width: '50',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell'},
        {label: '维修费',prop: 'payCostInfo.maintainFee',width: '50',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell'},
        {label: '现金加油费',prop: 'payCostInfo.refuelFee',width: '70',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell'},
        {label: '现金过路费',prop: 'payCostInfo.passingFee',width: '70',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell'},
        {label: '油卡费',prop: 'payCostInfo.refuelCardFee',width: '65',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell'},
        {label: '粤通卡费',prop: 'payCostInfo.passingCardFee',width: '60',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell'},
        {label: '其他费用',prop: 'payCostInfo.otherFee',width: '60',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell'},
        {label: '其他费用备注',prop: 'payCostInfo.otherFeeRemark',check: true,fixed: undefined,styleClass: 'my-table-cell'},
        {label: '司机借支',prop: 'payCostInfo.driverBorrowing',width: '60',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell'},
        {label: '扣款',prop: 'payCostInfo.deductionsFee',width: '40',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell'},
        {label: '装卸费',prop: 'driverRoyalty.loadFee',width: '50',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '住宿费',prop: 'driverRoyalty.stayFee',width: '50',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '加班费',prop: 'driverRoyalty.extraFee',width: '50',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '司机提成费',prop: 'driverRoyalty.royaltyFee',width: '70',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '基本工资',prop: 'driverRoyalty.baseFee',width: '60',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '绩效工资',prop: 'driverRoyalty.meritsFee',width: '60',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '使用APP奖励',prop: 'driverRoyalty.appFee',width: '80',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '租房费',prop: 'driverRoyalty.other1Fee',width: '50',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '油耗奖励',prop: 'driverRoyalty.other2Fee',width: '60',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '司机费用小计',prop: 'driverRoyalty.payableAmount',width: '80',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '请假扣款',prop: 'driverRoyalty.accumulationFund',width: '50',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '扣减安全奖',prop: 'driverRoyalty.safetyAward',width: '70',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '扣减违章/油耗',prop: 'driverRoyalty.oilConsumption',width: '90',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '分摊水电费',prop: 'driverRoyalty.hydropower',width: '70',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '个税',prop: 'driverRoyalty.personalIncomeTax',width: '40',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '司机借支',prop: 'driverRoyalty.driverBorrowing',width: '60',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '扣社保/公积金',prop: 'driverRoyalty.deductionsFee',width: '85',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '其他费用',prop: 'driverRoyalty.otherExpenses',width: '60',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '费用图片',prop: 'costImage',width: '60',check: true,fixed: undefined},
        {label: '件数',prop: 'orderGoods.pieceNum',width: '40',check: true,fixed: undefined},
        {label: '体积',prop: 'orderGoods.volume',width: '40',check: true,fixed: undefined},
        {label: '重量',prop: 'orderGoods.weight',width: '40',check: true,fixed: undefined},
        {label: '指派车型',prop: 'vehiclePlan.vehicleTypeName',width: '80',check: true,fixed: undefined},
        {label: '司机姓名',prop: 'vehiclePlan.driverName',width: '60',check: true,fixed: undefined},
        {label: '司机电话',prop: 'vehiclePlan.driverPhone',width: '90',check: true,fixed: undefined,formatter: 'maskMobileTable'},
        {label: '客户单号',prop: 'orderInfo.customerSelfNo',width: '100',check: true,fixed: undefined},
        {label: '客户联系人',prop: 'orderInfo.customerContactName',width: '60',check: true,fixed: undefined},
        {label: '客户联系电话',prop: 'orderInfo.customerContactPhone',width: '90',check: true,fixed: undefined,formatter: 'maskMobileTable'},
        {label: '下单时间',prop: 'orderInfo.commitTime',width: '120',check: true,fixed: undefined},
        {label: '下单人',prop: 'orderInfo.commitName',width: '70',check: true,fixed: undefined},
        {label: '订单号',prop: 'orderInfo.orderNo',width: '110',check: true,fixed: undefined},
        {label: '车次号',prop: 'vehiclePlan.planNo',width: '110',check: true,fixed: undefined},
        {label: '订单状态',prop: 'status',width: '60',check: true,fixed: undefined},
        {label: '确认状态',prop: '确认状态',width: '70',check: true,fixed: undefined},
        {label: '客服状态',width: '60',prop: '客服状态',fixed: 'right',check: true},
        {label: '主管状态',width: '60',prop: '主管状态',fixed: 'right',check: true},
        {label: '财务状态',width: '60',prop: '财务状态',fixed: 'right',check: true},
    ],
    configDefaultPropColumn: [],
    isConfigMode: false,
    configModeForm: {
        name: '',
        remark: '',
        defaultOrNot: '0'
    },
    configDefaultPropColumnMap: new Map(),
}

// 费用管理-应付费用池
export const supplierFee = {
    configId: null,
    configTableId: 18,
    configDefaultColumn: [
        {label: '提货时间',prop: 'deliveryTimeNode',fixed: undefined,width: '105',check: true},
        {label: '进仓单号',prop: 'orderInfo.inWarehouseNo',fixed: undefined,width: '60',check: true},
        {label: '司机车牌',prop: 'vehiclePlan.vehiclePlate',width: '70',check: true,fixed: undefined},
        {label: '实际车型',prop: 'orderInfo.vehicleType',width: '80',formatter: 'dictConvertVehicle',check: true,fixed: undefined},
        {label: '报关方式',prop: 'orderInfo.entranceType',width: '80',formatter: 'entranceType',check: true,fixed: undefined},
        {label: '订单类型',prop: 'orderInfo.orderType',width: '60',formatter: 'orderType',check: true,fixed: undefined},
        {label: '供应商',prop: 'vehiclePlan.motorcadeName',fixed: undefined,width: '80',check: true},
        {label: '提货地址',prop: 'fullAddress',width: '180',check: true,fixed: undefined},
        {label: '收货地址',prop: 'giveAddressInfo.fullAddress',width: '180',check: true,fixed: undefined},
        {label: '费用小计',prop: 'costInfo.totalMoney',width: '80',formatter: 'getNumValue',check: true,fixed: undefined},
        {label: '已付小计',prop: 'costInfo.paidAmount',width: '80',formatter: 'getNumValue',check: true,fixed: undefined},
        {label: '未付小计',prop: 'costInfo.notPayAmount',width: '80',formatter: 'getNumValue',check: true,fixed: undefined},
        {label: '运费',prop: 'costInfo.freightFee',width: '80',formatter: 'getNumValue',check: true,fixed: undefined},
        {label: '报关/入仓费',prop: 'costInfo.entranceFee',width: '75',formatter: 'getNumValue',check: true,fixed: undefined},
        {label: '高速费',prop: 'costInfo.highFee',width: '50',formatter: 'getNumValue',check: true,fixed: undefined},
        {label: '过磅费',prop: 'costInfo.weighFee',width: '50',formatter: 'getNumValue',check: true,fixed: undefined},
        {label: '装卸费',prop: 'costInfo.loadFee',width: '50',formatter: 'getNumValue',check: true,fixed: undefined},
        {label: '押夜/超时费',prop: 'costInfo.overtimeFee',width: '70',formatter: 'getNumValue',check: true,fixed: undefined},
        {label: '提货费',prop: 'costInfo.takeFee',width: '50',formatter: 'getNumValue',check: true,fixed: undefined},
        {label: '加点费',prop: 'costInfo.addFee',width: '50',formatter: 'getNumValue',check: true,fixed: undefined},
        {label: '停车费',prop: 'costInfo.parkingFee',width: '50',formatter: 'getNumValue',check: true,fixed: undefined},
        {label: '打印费',prop: 'costInfo.printFee',width: '50',formatter: 'getNumValue',check: true,fixed: undefined},
        {label: '维修费',prop: 'costInfo.maintainFee',width: '50',formatter: 'getNumValue',check: true,fixed: undefined},
        {label: '现金加油费',prop: 'costInfo.refuelFee',width: '50',formatter: 'getNumValue',check: true,fixed: undefined},
        {label: '现金过路费',prop: 'costInfo.passingFee',width: '50',formatter: 'getNumValue',check: true,fixed: undefined},
        {label: '油卡费',prop: 'costInfo.refuelCardFee',width: '50',formatter: 'getNumValue',check: true,fixed: undefined},
        {label: '粤通卡费',prop: 'costInfo.passingCardFee',width: '50',formatter: 'getNumValue',check: true,fixed: undefined},
        {label: '其他费用',prop: 'costInfo.otherFee',width: '60',formatter: 'getNumValue',check: true,fixed: undefined},
        {label: '其他费用备注',prop: 'costInfo.otherFeeRemark',width: '60',check: true,fixed: undefined},
        {label: '平台代垫',prop: 'costInfo.platformPrepayment',width: '60',check: true,fixed: undefined},
        {label: '司机代垫',prop: 'costInfo.driverPrepayment',width: '60',check: true,fixed: undefined},
        {label: '扣款',prop: 'costInfo.deductionsFee',width: '60',formatter: 'getNumValue',check: true,fixed: undefined},
        {label: '司机借支',prop: 'costInfo.driverBorrowing',width: '60',formatter: 'getNumValue',check: true,fixed: undefined},
        {label: '司机借支备注',prop: 'costInfo.borrowingRemark',width: '90',check: true,fixed: undefined},
        {label: '客服备注',prop: 'orderInfo.companyRemark',width: '90',check: true,fixed: undefined},
        {label: '件数',prop: 'orderGoods.pieceNum',width: '60',check: true,fixed: undefined},
        {label: '体积',prop: 'orderGoods.volume',width: '40',check: true,fixed: undefined},
        {label: '重量',prop: 'orderGoods.weight',width: '40',check: true,fixed: undefined},
        {label: '司机姓名',prop: 'vehiclePlan.driverName',width: '60',check: true,fixed: undefined},
        {label: '司机电话',prop: 'vehiclePlan.driverPhone',width: '90',check: true,fixed: undefined,formatter: 'maskMobileTable'},
        {label: '客户单号',prop: 'orderInfo.customerSelfNo',width: '100',check: true,fixed: undefined},
        {label: '订单号',prop: 'orderInfo.orderNo',width: '110',check: true,fixed: undefined},
        {label: '车次号',prop: 'vehiclePlan.planNo',width: '110',check: true,fixed: undefined},
        {label: '应付车型',prop: 'vehiclePlan.vehicleTypeName',width: '80',check: true,fixed: undefined},
        {label: '付款人',prop: 'costInfo.writeName',width: '50',check: true,fixed: undefined},
        {label: '付款时间',prop: 'costInfo.writeDate',width: '70',check: true,fixed: undefined},
        {label: '账单状态',fixed: undefined,prop: 'genStatus',width: '60',check: true},
        {label: '付款状态',prop: 'writeStatus',width: '60',check: true, fixed: 'right'},
        {label: '签收单状态',prop: 'orderInfo.writeStatus',width: '70',check: true,fixed: 'right'},
    ],
    configDefaultPropColumn: [],
    isConfigMode: false,
    configModeForm: {
        name: '',
        remark: '',
        defaultOrNot: '0'
    },
}

// 费用管理-供应商费用池
export const orderSupplierFee = {
    configId: null,
    configTableId: 19,
    configDefaultColumn: [
        {label: '提货时间',prop: 'deliveryTimeNode',fixed: 'left',width: '105',check: true},
        {label: '进仓单号',prop: 'orderInfo.inWarehouseNo',fixed: 'left',width: '60',check: true},
        {label: '司机车牌',prop: 'vehiclePlan.vehiclePlate',width: '70',check: true,fixed: 'left'},
        {label: '实际车型',prop: 'orderInfo.vehicleType',width: '80',formatter: 'dictConvertVehicle',check: true,fixed: undefined},
        {label: '报关方式',prop: 'orderInfo.entranceType',width: '80',formatter: 'entranceType',check: true,fixed: undefined},
        {label: '订单类型',prop: 'orderInfo.orderType',width: '60',formatter: 'orderType',check: true,fixed: undefined},
        {label: '供应商',prop: 'vehiclePlan.motorcadeName',fixed: undefined,width: '80',check: true},
        {label: '提货地址',prop: 'fullAddress',width: '180',check: true,fixed: undefined},
        {label: '收货地址',prop: 'giveAddressInfo.fullAddress',width: '180',check: true,fixed: undefined},
        {label: '运费',prop: 'supplierCost.freightFee',width: '80',formatter: 'getNumValue',check: true,fixed: undefined},
        {label: '其他费用',prop: 'supplierCost.otherFee',width: '60',formatter: 'getNumValue',check: true,fixed: undefined},
        {label: '备注',prop: 'supplierCost.remark',fixed: undefined,width: '80',check: true},
        {label: '费用小计',prop: 'payableAmounts',width: '80',formatter: 'getNumValue',check: true,fixed: undefined},
        {label: '已付小计',prop: 'paidAmounts',width: '80',formatter: 'getNumValue',check: true,fixed: undefined},
        {label: '未付小计',prop: 'notPayableAmounts',width: '80',formatter: 'getNumValue',check: true,fixed: undefined},
        {label: '收款人',prop: 'supplierCost.payeeUser',fixed: undefined,width: '80',check: true},
        {label: '收款人',prop: 'supplierCost.payeePhone',fixed: undefined,width: '80',check: true},
        {label: '司机姓名',prop: 'vehiclePlan.driverName',width: '60',check: true,fixed: undefined},
        {label: '司机电话',prop: 'vehiclePlan.driverPhone',width: '90',check: true,fixed: undefined,formatter: 'maskMobileTable'},
        {label: '客户单号',prop: 'orderInfo.customerSelfNo',width: '100',check: true,fixed: undefined},
        {label: '订单号',prop: 'orderInfo.orderNo',width: '110',check: true,fixed: undefined},
        {label: '车次号',prop: 'vehiclePlan.planNo',width: '110',check: true,fixed: undefined},
        {label: '应付车型',prop: 'vehiclePlan.vehicleTypeName',width: '80',check: true,fixed: undefined},
        {label: '付款状态',prop: '付款状态',width: '60',check: true, fixed: 'right'},
        {label: '审核状态',prop: '审核状态',width: '70',check: true,fixed: 'right'},
    ],
    configDefaultPropColumn: [],
    isConfigMode: false,
    configModeForm: {
        name: '',
        remark: '',
        defaultOrNot: '0'
    },
}

// 费用管理-运输部费用池
export const baseCost = {
    configId: null,
    configTableId: 20,
    configDefaultColumn: [
        {label: '提货时间',prop: 'deliveryTimeNode',fixed: 'left',width: '105',check: true},
        {label: '进仓单号',prop: 'orderInfo.inWarehouseNo',fixed: undefined,width: '80',check: true},
        {label: '司机车牌',prop: 'vehiclePlan.vehiclePlate',fixed: undefined,width: '70',check: true},
        {label: '司机姓名',prop: 'vehiclePlan.driverName',fixed: undefined,width: '60',check: true},
        {label: '订单类型',prop: 'orderTypeNode',width: '60',formatter: 'orderType',check: true,fixed: undefined},
        {label: '订单车型',prop: 'vehicleTypeNode',width: '80',formatter: 'dictConvertVehicle',check: true,fixed: undefined},
        {label: '提货地址',prop: 'route',width: '80',check: true,fixed: undefined},
        {label: '报关方式',prop: 'entranceTypeNode',width: '80',formatter: 'entranceType',check: true,fixed: undefined},
        {label: '收货地址',prop: 'giveAddressInfo.route',width: '80',check: true,fixed: undefined},
        {label: '司机电话',prop: 'vehiclePlan.driverPhone',width: '90',check: true,fixed: undefined,formatter: 'maskMobileTable'},
        {label: '应收运费',prop: 'driverRoyalty.freightFee',width: '60',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '加点费',prop: 'driverRoyalty.addFee',width: '50',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '押夜/超时费',prop: 'driverRoyalty.overtimeFee',width: '75',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '司机提成费',prop: 'driverRoyalty.royaltyFee',width: '70',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '装卸费',prop: 'driverRoyalty.loadFee',width: '50',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '加班费',prop: 'driverRoyalty.extraFee',width: '50',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '住宿费',prop: 'driverRoyalty.stayFee',width: '50',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '基本工资',prop: 'driverRoyalty.baseFee',width: '60',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '绩效工资',prop: 'driverRoyalty.meritsFee',width: '60',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '使用APP奖励',prop: 'driverRoyalty.appFee',width: '80',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '租房费',prop: 'driverRoyalty.other1Fee',width: '50',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '油耗奖励',prop: 'driverRoyalty.other2Fee',width: '60',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '安全奖罚金',prop: 'driverRoyalty.safetyRewards',width: '60',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '司机费用小计',prop: 'driverRoyalty.payableAmount',width: '80',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '已付小计',prop: 'driverRoyalty.paidAmount',width: '70',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '未付小计',prop: 'driverRoyalty.notPayAmount',width: '70',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '扣社保/公积金',prop: 'driverRoyalty.deductionsFee',width: '85',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '请假扣款',prop: 'driverRoyalty.accumulationFund',width: '50',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '扣减安全奖',prop: 'driverRoyalty.safetyAward',width: '70',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '扣减违章/油耗',prop: 'driverRoyalty.oilConsumption',width: '90',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '分摊水电费',prop: 'driverRoyalty.hydropower',width: '70',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '个税',prop: 'driverRoyalty.personalIncomeTax',width: '40',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '其他费用(扣)',prop: 'driverRoyalty.otherExpenses',width: '60',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '实发小计',prop: 'driverRoyalty.netSalary',width: '60',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '借支',prop: 'driverRoyalty.driverBorrowing',width: '60',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '借支/扣款备注',prop: 'remark',width: '100',formatter: 'getNumValue',check: true,fixed: undefined},
        {label: '客服备注',prop: 'orderInfo.companyRemark',width: '80',check: true,fixed: undefined,formatter: 'getNumValue'},
        {label: '下单时间',prop: 'orderInfo.commitTime',width: '120',check: true,fixed: undefined},
        {label: '下单人',prop: 'orderInfo.commitName',width: '70',check: true,fixed: undefined},
        {label: '派车时间',prop: 'orderInfo.dispatchTime',width: '120"',check: true,fixed: undefined},
        {label: '出车时间',prop: 'outDriveTimeOsr',width: '120"',check: true,fixed: undefined},
        {label: '装货到场时间',prop: 'arrivedTimeOsr',width: '120"',check: true,fixed: undefined},
        {label: '装货离场时间',prop: 'loadGoodsTimeOsr',width: '120"',check: true,fixed: undefined},
        {label: '卸货到场时间',prop: 'arrivedGiveTimeOsr',width: '120"',check: true,fixed: undefined},
        {label: '签收时间',prop: 'orderInfo.successTime',width: '120"',check: true,fixed: undefined},
        {label: '签收时间',prop: 'orderInfo.successTime',width: '120"',check: true,fixed: undefined},
        {label: '订单状态',prop: 'status',width: '70"',check: true,fixed: undefined},
        {label: '付款人',prop: 'driverRoyalty.writeName',width: '50"',check: true,fixed: undefined},
        {label: '付款时间',prop: 'driverRoyalty.writeDate',width: '70"',check: true,fixed: undefined},
        {label: '审核状态',prop: '审核状态',width: '60"',check: true,fixed: 'right'},
        {label: '付款状态',prop: '付款状态',width: '60"',check: true,fixed: 'right'},
    ],
    configDefaultPropColumn: [],
    isConfigMode: false,
    configModeForm: {
        name: '',
        remark: '',
        defaultOrNot: '0'
    },
    configDefaultPropColumnMap: new Map(),
}

// 费用管理-业务员费用池
export const businessDepartment = {
    configId: null,
    configTableId: 21,
    configDefaultColumn: [
        {label: '提货时间',prop: 'deliveryTimeNode',fixed: 'left',width: '105',check: true},
        {label: '客户名称',prop: 'orderInfo.customerName',fixed: 'left',width: '70',check: true},
        {label: '进仓单号',prop: 'orderInfo.inWarehouseNo',fixed: 'left',width: '80',check: true},
        {label: '司机车牌',prop: 'vehiclePlan.vehiclePlate',fixed: 'left',width: '70',check: true},
        {label: '司机姓名',prop: 'vehiclePlan.driverName',fixed: 'left',width: '60',check: true},
        {label: '订单类型',prop: 'orderTypeNode',width: '60',formatter: 'orderType',check: true,fixed: undefined},
        {label: '订单车型',prop: 'vehicleTypeNode',width: '80',formatter: 'dictConvertVehicle',check: true,fixed: undefined},
        {label: '提货地址',prop: 'route',width: '80',check: true,fixed: undefined},
        {label: '报关方式',prop: 'entranceTypeNode',width: '80',formatter: 'entranceType',check: true,fixed: undefined},
        {label: '收货地址',prop: 'giveAddressInfo.route',width: '80',check: true,fixed: undefined},
        {label: '应收运费',prop: 'officeCostSale.freightFee',width: '80',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '加点费',prop: 'officeCostSale.addFee',width: '60',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '押夜/超时费',prop: 'officeCostSale.overtimeFee',width: '60',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '提成费',prop: 'officeCostSale.saleRoyaltyFee',width: '60',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '装卸费',prop: 'officeCostSale.loadFee',width: '60',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '加班费',prop: 'officeCostSale.extraFee',width: '60',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '住宿费',prop: 'officeCostSale.stayFee',width: '60',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '基本工资',prop: 'officeCostSale.saleBaseFee',width: '60',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '绩效奖罚金',prop: 'officeCostSale.meritsFee',width: '60',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: 'APP奖罚金',prop: 'officeCostSale.appFee',width: '60',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '租房费',prop: 'officeCostSale.other1Fee',width: '50',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '油耗奖励',prop: 'officeCostSale.other2Fee',width: '50',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '安全奖罚金',prop: 'officeCostSale.safetyRewards',width: '70',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '费用小计',prop: 'officeCostSale.payableAmount',width: '60',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '已付小计',prop: 'officeCostSale.paidAmount',width: '60',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '未付小计',prop: 'officeCostSale.notPayAmount',width: '60',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '扣社保/公积金',prop: 'officeCostSale.deductionsFee',width: '60',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '请假扣款',prop: 'officeCostSale.accumulationFund',width: '60',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '扣减安全奖',prop: 'officeCostSale.safetyAward',width: '60',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '扣减违章/油耗',prop: 'officeCostSale.oilConsumption',width: '90',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '分摊水电费',prop: 'officeCostSale.hydropower',width: '80',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '个税',prop: 'officeCostSale.personalIncomeTax',width: '50',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '其他费用(扣)',prop: 'officeCostSale.otherExpenses',width: '90',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '实发小计',prop: 'officeCostSale.netSalary',width: '60',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '借支',prop: 'officeCostSale.borrowing',width: '60',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '借支/扣款备注',prop: 'remark',width: '100',formatter: 'getNumValue',check: true,fixed: undefined},
        {label: '对接人',prop: 'officeCostSale.saleName',width: '70',formatter: 'getNumValue',check: true,fixed: undefined},
        {label: '件数',prop: 'orderGoods.pieceNum',width: '60',check: true,fixed: undefined},
        {label: '体积',prop: 'orderGoods.volume',width: '40',check: true,fixed: undefined},
        {label: '重量',prop: 'orderGoods.weight',width: '40',check: true,fixed: undefined},
        {label: '下单时间',prop: 'orderInfo.commitTime',width: '120',check: true,fixed: undefined},
        {label: '下单人',prop: 'orderInfo.commitName',width: '80',check: true,fixed: undefined},
        {label: '付款人',prop: 'officeCostSale.writeName',width: '50',check: true,fixed: undefined},
        {label: '付款时间',prop: 'officeCostSale.writeDate',width: '70',check: true,fixed: undefined},
        {label: '审核状态',prop: '审核状态',width: '60"',check: true,fixed: 'right'},
        {label: '付款状态',prop: '付款状态',width: '60"',check: true,fixed: 'right'},
    ],
    configDefaultPropColumn: [],
    isConfigMode: false,
    configModeForm: {
        name: '',
        remark: '',
        defaultOrNot: '0'
    },
    configDefaultPropColumnMap: new Map(),
}

// 费用管理-客服员费用池
export const customerServiceDepartment = {
    configId: null,
    configTableId: 23,
    configDefaultColumn: [
        {label: '提货时间',prop: 'deliveryTimeNode',fixed: 'left',width: '105',check: true},
        {label: '客户名称',prop: 'orderInfo.customerName',fixed: 'left',width: '70',check: true},
        {label: '进仓单号',prop: 'orderInfo.inWarehouseNo',fixed: 'left',width: '80',check: true},
        {label: '司机车牌',prop: 'vehiclePlan.vehiclePlate',fixed: 'left',width: '70',check: true},
        {label: '司机姓名',prop: 'vehiclePlan.driverName',fixed: 'left',width: '60',check: true},
        {label: '订单类型',prop: 'orderTypeNode',width: '60',formatter: 'orderType',check: true,fixed: undefined},
        {label: '订单车型',prop: 'vehicleTypeNode',width: '80',formatter: 'dictConvertVehicle',check: true,fixed: undefined},
        {label: '提货地址',prop: 'route',width: '80',check: true,fixed: undefined},
        {label: '报关方式',prop: 'entranceTypeNode',width: '80',formatter: 'entranceType',check: true,fixed: undefined},
        {label: '收货地址',prop: 'giveAddressInfo.route',width: '80',check: true,fixed: undefined},
        {label: '应收运费',prop: 'officeCostCare.freightFee',width: '60',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '加点费',prop: 'officeCostCare.addFee',width: '50',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '押夜/超时费',prop: 'officeCostCare.overtimeFee',width: '75',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '提成费',prop: 'officeCostCare.careRoyaltyFee',width: '75',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '装卸费',prop: 'officeCostCare.loadFee',width: '50',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '加班费',prop: 'officeCostCare.extraFee',width: '50',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '住宿费',prop: 'officeCostCare.stayFee',width: '50',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '基本工资',prop: 'officeCostCare.careBaseFee',width: '50',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '绩效工资',prop: 'officeCostCare.meritsFee',width: '60',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '使用APP奖励',prop: 'officeCostCare.appFee',width: '80',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '租房费',prop: 'officeCostCare.other1Fee',width: '50',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '油耗奖励',prop: 'officeCostCare.other2Fee',width: '60',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '安全奖罚金',prop: 'officeCostCare.safetyRewards',width: '60',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '费用小计',prop: 'officeCostCare.payableAmount',width: '60',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '已付小计',prop: 'officeCostCare.paidAmount',width: '70',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '未付小计',prop: 'officeCostCare.notPayAmount',width: '70',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '扣社保/公积金',prop: 'officeCostCare.deductionsFee',width: '85',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '请假扣款',prop: 'officeCostCare.accumulationFund',width: '50',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '扣减安全奖',prop: 'officeCostCare.safetyAward',width: '70',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '扣减违章/油耗',prop: 'officeCostCare.oilConsumption',width: '90',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '分摊水电费',prop: 'officeCostCare.hydropower',width: '70',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '个税',prop: 'officeCostCare.personalIncomeTax',width: '40',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '其他费用',prop: 'officeCostCare.otherExpenses',width: '40',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '实发小计',prop: 'officeCostCare.netSalary',width: '40',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '借支',prop: 'officeCostCare.borrowing',width: '40',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '备注',prop: 'officeCostCare.remark',width: '40',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '对接人',prop: 'officeCostCare.careName',width: '40',check: true,fixed: undefined},
        {label: '订单状态',prop: 'status',width: '70"',check: true,fixed: undefined},
        {label: '件数',prop: 'orderGoods.pieceNum',width: '40',check: true,fixed: undefined},
        {label: '体积',prop: 'orderGoods.volume',width: '40',check: true,fixed: undefined},
        {label: '重量',prop: 'orderGoods.weight',width: '40',check: true,fixed: undefined},
        {label: '下单时间',prop: 'orderInfo.commitTime',width: '120',check: true,fixed: undefined},
        {label: '下单人',prop: 'orderInfo.commitName',width: '70',check: true,fixed: undefined},
        {label: '付款人',prop: 'officeCostCare.writeName',width: '50"',check: true,fixed: undefined},
        {label: '付款时间',prop: 'officeCostCare.writeDate',width: '70"',check: true,fixed: undefined},
        {label: '审核状态',prop: '审核状态',width: '60"',check: true,fixed: 'right'},
        {label: '付款状态',prop: '付款状态',width: '60"',check: true,fixed: 'right'},
    ],
    configDefaultPropColumn: [],
    isConfigMode: false,
    configModeForm: {
        name: '',
        remark: '',
        defaultOrNot: '0'
    },
    configDefaultPropColumnMap: new Map(),
}

// 费用管理-业务经理费用池
export const adminBusinessDepartment = {
    configId: null,
    configTableId: 22,
    configDefaultColumn: [
        {label: '提货时间',prop: 'deliveryTimeNode',fixed: 'left',width: '105',check: true},
        {label: '客户名称',prop: 'orderInfo.customerName',fixed: 'left',width: '70',check: true},
        {label: '进仓单号',prop: 'orderInfo.inWarehouseNo',fixed: 'left',width: '80',check: true},
        {label: '司机车牌',prop: 'vehiclePlan.vehiclePlate',fixed: 'left',width: '70',check: true},
        {label: '司机姓名',prop: 'vehiclePlan.driverName',fixed: 'left',width: '60',check: true},
        {label: '订单类型',prop: 'orderTypeNode',width: '60',formatter: 'orderType',check: true,fixed: undefined},
        {label: '订单车型',prop: 'vehicleTypeNode',width: '80',formatter: 'dictConvertVehicle',check: true,fixed: undefined},
        {label: '提货地址',prop: 'route',width: '80',check: true,fixed: undefined},
        {label: '报关方式',prop: 'entranceTypeNode',width: '80',formatter: 'entranceType',check: true,fixed: undefined},
        {label: '收货地址',prop: 'giveAddressInfo.route',width: '80',check: true,fixed: undefined},
        {label: '应收运费',prop: 'officeCostSale.freightFee',width: '80',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '加点费',prop: 'officeCostSale.addFee',width: '60',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '押夜/超时费',prop: 'officeCostSale.overtimeFee',width: '60',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '提成费',prop: 'officeCostSale.saleRoyaltyFee',width: '60',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '装卸费',prop: 'officeCostSale.loadFee',width: '60',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '加班费',prop: 'officeCostSale.extraFee',width: '60',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '住宿费',prop: 'officeCostSale.stayFee',width: '60',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '基本工资',prop: 'officeCostSale.saleBaseFee',width: '60',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '绩效奖罚金',prop: 'officeCostSale.meritsFee',width: '60',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: 'APP奖罚金',prop: 'officeCostSale.appFee',width: '60',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '租房费',prop: 'officeCostSale.other1Fee',width: '50',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '油耗奖励',prop: 'officeCostSale.other2Fee',width: '50',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '安全奖罚金',prop: 'officeCostSale.safetyRewards',width: '70',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '费用小计',prop: 'officeCostSale.payableAmount',width: '60',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '已付小计',prop: 'officeCostSale.paidAmount',width: '60',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '未付小计',prop: 'officeCostSale.notPayAmount',width: '60',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '扣社保/公积金',prop: 'officeCostSale.deductionsFee',width: '60',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '请假扣款',prop: 'officeCostSale.accumulationFund',width: '60',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '扣减安全奖',prop: 'officeCostSale.safetyAward',width: '60',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '扣减违章/油耗',prop: 'officeCostSale.oilConsumption',width: '90',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '分摊水电费',prop: 'officeCostSale.hydropower',width: '80',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '个税',prop: 'officeCostSale.personalIncomeTax',width: '50',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '其他费用(扣)',prop: 'officeCostSale.otherExpenses',width: '90',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '实发小计',prop: 'officeCostSale.netSalary',width: '60',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '借支',prop: 'officeCostSale.borrowing',width: '60',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '借支/扣款备注',prop: 'officeCostSale.remark',width: '100',formatter: 'getNumValue',check: true,fixed: undefined},
        {label: '对接人',prop: 'officeCostSale.saleName',width: '70',check: true,fixed: undefined},
        {label: '订单状态',prop: 'status',width: '70',check: true,fixed: undefined},
        {label: '件数',prop: 'orderGoods.pieceNum',width: '60',check: true,fixed: undefined},
        {label: '体积',prop: 'orderGoods.volume',width: '40',check: true,fixed: undefined},
        {label: '重量',prop: 'orderGoods.weight',width: '40',check: true,fixed: undefined},
        {label: '下单时间',prop: 'orderInfo.commitTime',width: '120',check: true,fixed: undefined},
        {label: '下单人',prop: 'orderInfo.commitName',width: '80',check: true,fixed: undefined},
        {label: '付款人',prop: 'officeCostSale.writeName',width: '50',check: true,fixed: undefined},
        {label: '付款时间',prop: 'officeCostSale.writeDate',width: '70',check: true,fixed: undefined},
        {label: '审核状态',prop: '审核状态',width: '60"',check: true,fixed: 'right'},
        {label: '付款状态',prop: '付款状态',width: '60"',check: true,fixed: 'right'},
    ],
    configDefaultPropColumn: [],
    isConfigMode: false,
    configModeForm: {
        name: '',
        remark: '',
        defaultOrNot: '0'
    },
    configDefaultPropColumnMap: new Map(),
}

// 费用管理-客服经理费用池
export const adminServiceDepartment = {
    configId: null,
    configTableId: 24,
    configDefaultColumn: [
        {label: '提货时间',prop: 'deliveryTimeNode',fixed: 'left',width: '105',check: true},
        {label: '客户名称',prop: 'orderInfo.customerName',fixed: 'left',width: '70',check: true},
        {label: '进仓单号',prop: 'orderInfo.inWarehouseNo',fixed: 'left',width: '80',check: true},
        {label: '司机车牌',prop: 'vehiclePlan.vehiclePlate',fixed: 'left',width: '70',check: true},
        {label: '司机姓名',prop: 'vehiclePlan.driverName',fixed: 'left',width: '60',check: true},
        {label: '订单类型',prop: 'orderTypeNode',width: '60',formatter: 'orderType',check: true,fixed: undefined},
        {label: '订单车型',prop: 'vehicleTypeNode',width: '80',formatter: 'dictConvertVehicle',check: true,fixed: undefined},
        {label: '提货地址',prop: 'route',width: '80',check: true,fixed: undefined},
        {label: '报关方式',prop: 'entranceTypeNode',width: '80',formatter: 'entranceType',check: true,fixed: undefined},
        {label: '收货地址',prop: 'giveAddressInfo.route',width: '80',check: true,fixed: undefined},
        {label: '应收运费',prop: 'officeCostCare.freightFee',width: '60',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '加点费',prop: 'officeCostCare.addFee',width: '50',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '押夜/超时费',prop: 'officeCostCare.overtimeFee',width: '75',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '提成费',prop: 'officeCostCare.careRoyaltyFee',width: '75',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '装卸费',prop: 'officeCostCare.loadFee',width: '50',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '加班费',prop: 'officeCostCare.extraFee',width: '50',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '住宿费',prop: 'officeCostCare.stayFee',width: '50',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '基本工资',prop: 'officeCostCare.careBaseFee',width: '50',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '绩效奖罚金',prop: 'officeCostCare.meritsFee',width: '60',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '使用APP奖励',prop: 'officeCostCare.appFee',width: '80',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '租房费',prop: 'officeCostCare.other1Fee',width: '50',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '油耗奖励',prop: 'officeCostCare.other2Fee',width: '60',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '安全奖罚金',prop: 'officeCostCare.safetyRewards',width: '60',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '费用小计',prop: 'officeCostCare.payableAmount',width: '60',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '已付小计',prop: 'officeCostCare.paidAmount',width: '70',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '未付小计',prop: 'officeCostCare.notPayAmount',width: '70',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '扣社保/公积金',prop: 'officeCostCare.deductionsFee',width: '85',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '请假扣款',prop: 'officeCostCare.accumulationFund',width: '50',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '扣减安全奖',prop: 'officeCostCare.safetyAward',width: '70',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '扣减违章/油耗',prop: 'officeCostCare.oilConsumption',width: '90',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '分摊水电费',prop: 'officeCostCare.hydropower',width: '70',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '个税',prop: 'officeCostCare.personalIncomeTax',width: '40',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '其他费用',prop: 'officeCostCare.otherExpenses',width: '40',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '实发小计',prop: 'officeCostCare.netSalary',width: '40',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '借支',prop: 'officeCostCare.borrowing',width: '40',formatter: 'getNumValue',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '备注',prop: 'officeCostCare.remark',width: '40',check: true,fixed: undefined,styleClass: 'my-table-cell-v2'},
        {label: '对接人',prop: 'officeCostCare.careName',width: '40',check: true,fixed: undefined},
        {label: '订单状态',prop: 'status',width: '70"',check: true,fixed: undefined},
        {label: '件数',prop: 'orderGoods.pieceNum',width: '40',check: true,fixed: undefined},
        {label: '体积',prop: 'orderGoods.volume',width: '40',check: true,fixed: undefined},
        {label: '重量',prop: 'orderGoods.weight',width: '40',check: true,fixed: undefined},
        {label: '下单时间',prop: 'orderInfo.commitTime',width: '120',check: true,fixed: undefined},
        {label: '下单人',prop: 'orderInfo.commitName',width: '70',check: true,fixed: undefined},
        {label: '付款人',prop: 'officeCostCare.writeName',width: '50"',check: true,fixed: undefined},
        {label: '付款时间',prop: 'officeCostCare.writeDate',width: '70"',check: true,fixed: undefined},
        {label: '审核状态',prop: '审核状态',width: '60"',check: true,fixed: 'right'},
        {label: '付款状态',prop: '付款状态',width: '60"',check: true,fixed: 'right'},
    ],
    configDefaultPropColumn: [],
    isConfigMode: false,
    configModeForm: {
        name: '',
        remark: '',
        defaultOrNot: '0'
    },
    configDefaultPropColumnMap: new Map(),
}

// 客户管理-客户注册审核
export const customsRegister = {
    configId: null,
    configTableId: 38,
    configDefaultColumn: [
        {label: '企业名称',prop: 'fullName',fixed: 'left',width: '100',check: true},
        {label: '企业信用代码',prop: 'creditCode',width: '100',check: true,fixed: undefined},
        {label: '申请人',prop: 'contactName',check: true,fixed: undefined},
        {label: '联系电话',prop: 'contactPhone',check: true,fixed: undefined,formatter: 'maskMobileTable'},
        {label: '认证类型',prop: 'realType',check: true,fixed: undefined,formatter: 'dictConvert'},
        {label: '身份证号码',prop: 'numberCard',check: true,fixed: undefined},
        {label: '地址',prop: 'address',check: true,fixed: undefined},
        {label: '个人邮箱',prop: 'email',check: true,fixed: undefined},
        {label: '是否接收邮件',prop: 'receiveEmail',check: true,fixed: undefined,formatter: 'yesNo'},
        {label: '申请时间',prop: 'applyTime',width: '120',check: true,fixed: undefined},
        {label: '身份证正面',prop: '身份证正面',check: true,fixed: undefined},
        {label: '身份证反面',prop: '身份证反面',check: true,fixed: undefined},
        {label: '营业执照',prop: '营业执照',check: true,fixed: undefined},
        {label: '状态',prop: 'status',width: '50',check: true,fixed: undefined},
    ],
    configDefaultPropColumn: [],
    isConfigMode: false,
    configModeForm: {
        name: '',
        remark: '',
        defaultOrNot: '0'
    },
    configDefaultPropColumnMap: new Map(),
}

// 客户管理-客户地址薄
export const customerAddress = {
    configId: null,
    configTableId: 40,
    configDefaultColumn: [
        {label: '地址类型',prop: 'addressType',width: '60',check: true,fixed: undefined},
        {label: '客户代码',prop: 'customerCode',check: true,fixed: undefined},
        {label: '客户名称',prop: 'customerName',check: true,fixed: undefined},
        {label: '工厂/仓库名称',prop: 'simpleName',check: true,fixed: undefined},
        {label: '详细地址',prop: 'fullAddress',check: true,fixed: undefined},
        {label: '联系人',prop: 'contactName',check: true,fixed: undefined},
        {label: '联系电话',prop: 'contactPhone',check: true,fixed: undefined,formatter: 'maskMobileTable'},
        {label: '注意事项',prop: 'remark',check: true,fixed: undefined},
        {label: '状态',prop: 'status',check: true,fixed: 'right',width: '40'},
    ],
    configDefaultPropColumn: [],
    isConfigMode: false,
    configModeForm: {
        name: '',
        remark: '',
        defaultOrNot: '0'
    },
    configDefaultPropColumnMap: new Map(),
}

// 客户管理-公用地址簿
export const customerPublicAddress = {
    configId: null,
    configTableId: 41,
    configDefaultColumn: [
        {label: '地址类型',prop: 'addressType',width: '60',check: true,fixed: undefined},
        {label: '工厂/仓库名称',prop: 'simpleName',check: true,fixed: undefined,width: '150'},
        {label: '详细地址',prop: 'fullAddress',check: true,fixed: undefined},
        {label: '联系人',prop: 'contactName',check: true,fixed: undefined,width: '120'},
        {label: '联系电话',prop: 'contactPhone',check: true,fixed: undefined,width: '320',formatter: 'maskMobileTable'},
        {label: '注意事项',prop: 'remark',check: true,fixed: undefined},
        {label: '状态',prop: 'status',check: true,fixed: 'right',width: '40'},
    ],
    configDefaultPropColumn: [],
    isConfigMode: false,
    configModeForm: {
        name: '',
        remark: '',
        defaultOrNot: '0'
    },
    configDefaultPropColumnMap: new Map(),
}

// 运力管理-注册信息审核
export const transportRegister = {
    configId: null,
    configTableId: 32,
    configDefaultColumn: [
        {label: '驾驶员姓名',prop: 'name',width: '80',check: true,fixed: undefined},
        {label: '联系电话',prop: 'contactPhone',width: '90',check: true,fixed: undefined,formatter: 'maskMobileTable'},
        {label: '注册城市',prop: 'registerCity',width: '90',check: true,fixed: undefined},
        {label: '现居住地址',prop: 'address',width: '90',check: true,fixed: undefined},
        {label: '身份证号码',prop: 'cardNo',width: '130',check: true,fixed: undefined},
        {label: '准驾类型',prop: 'proofType',formatter: 'dictConvert',width: '90',check: true,fixed: undefined},
        {label: '是否自带车',prop: 'isHaveVehicle',formatter: 'yesNo',width: '90',check: true,fixed: undefined},
        {label: '紧急联系电话',prop: 'urgentPhone',width: '90',check: true,fixed: undefined,formatter: 'maskMobileTable'},
        {label: '所属车队',prop: 'motorcadeName',width: '90',check: true,fixed: undefined},
        {label: '身份证正面',prop: '身份证正面',width: '70',check: true,fixed: undefined},
        {label: '身份证反面',prop: '身份证反面',width: '70',check: true,fixed: undefined},
        {label: '驾驶证',prop: '驾驶证',width: '70',check: true,fixed: undefined},
        {label: '从业资格证',prop: '从业资格证',width: '70',check: true,fixed: undefined},
        {label: '行驶证',prop: '行驶证',width: '50',check: true,fixed: undefined},
        {label: '车辆图片',prop: '车辆图片',width: '50',check: true,fixed: undefined},
        {label: '交强险',prop: '交强险',width: '50',check: true,fixed: undefined},
        {label: '商业险',prop: '商业险',width: '50',check: true,fixed: undefined},
        {label: '车辆营运证',prop: '车辆营运证',width: '50',check: true,fixed: undefined},
        {label: '状态',prop: 'status',width: '50',check: true,fixed: undefined},
    ],
    configDefaultPropColumn: [],
    isConfigMode: false,
    configModeForm: {
        name: '',
        remark: '',
        defaultOrNot: '0'
    },
    configDefaultPropColumnMap: new Map(),
}

// 运力管理-运输公司信息
export const baseCompany = {
    configId: null,
    configTableId: 33,
    configDefaultColumn: [
        {label: '公司编号',prop: 'companyNo',check: true,fixed: undefined},
        {label: '公司全称',prop: 'fullName',check: true,fixed: undefined},
        {label: '公司简称',prop: 'simpleName',check: true,fixed: undefined},
        {label: '企业信用代码',prop: 'creditCode',check: true,fixed: undefined},
        {label: '联系人名称',prop: 'contactName',check: true,fixed: undefined},
        {label: '联系电话',prop: 'contactPhone',check: true,fixed: undefined,formatter: 'maskMobileTable'},
        {label: '地址',prop: 'address',check: true,fixed: undefined},
        {label: '状态',prop: 'status',width: '40',check: true,fixed: undefined},
    ],
    configDefaultPropColumn: [],
    isConfigMode: false,
    configModeForm: {
        name: '',
        remark: '',
        defaultOrNot: '0'
    },
    configDefaultPropColumnMap: new Map(),
}

// 运力管理-车队信息
export const transportMotorcade = {
    configId: null,
    configTableId: 34,
    configDefaultColumn: [
        {label: '车队编号',prop: 'motorcadeCode',check: true,fixed: undefined},
        {label: '所属公司',prop: 'companyName',check: true,fixed: undefined},
        {label: '车队全称',prop: 'fullName',check: true,fixed: undefined},
        {label: '车队简称',prop: 'simpleName',check: true,fixed: undefined},
        {label: '联系人',prop: 'contactName',check: true,fixed: undefined},
        {label: '联系电话',prop: 'contactPhone',check: true,fixed: undefined,formatter: 'maskMobileTable'},
        {label: '详细地址',prop: 'address',check: true,fixed: undefined},
        {label: '结算周期(天)',prop: 'settleCycle',check: true,fixed: undefined},
        {label: '所属类型',prop: 'motorcadeType',formatter: 'motorcadeType',width: '120',check: true,fixed: undefined},
        {label: '状态',prop: 'status',width: '50',check: true,fixed: undefined},
    ],
    configDefaultPropColumn: [],
    isConfigMode: false,
    configModeForm: {
        name: '',
        remark: '',
        defaultOrNot: '0'
    },
    configDefaultPropColumnMap: new Map(),
}

// 员工管理-考勤记录
export const clockIn = {
    configId: null,
    configTableId: 52,
    configDefaultColumn: [
        {label: '考勤日期',prop: 'attendanceDate',check: true,fixed: undefined},
        {label: '真实姓名',prop: 'userRealName',check: true,fixed: undefined},
        {label: '手机号',prop: 'userMobilePhone',check: true,fixed: undefined,formatter: 'maskMobileTable'},
        {label: '账号',prop: 'userAccount',check: true,fixed: undefined},
        {label: '上班打卡时间',prop: 'checkInTime',check: true,fixed: undefined},
        {label: '上班打卡地点',prop: 'checkInLocation',check: true,fixed: undefined},
        {label: '午休前打卡时间',prop: 'checkBeforeLunchTime',check: true,fixed: undefined},
        {label: '午休前打卡地点',prop: 'checkBeforeLunchLocation',check: true,fixed: undefined},
        {label: '午休后打卡时间',prop: 'checkAfterLunchTime',check: true,fixed: undefined},
        {label: '午休后打卡地点',prop: 'checkAfterLunchLocation',check: true,fixed: undefined},
        {label: '下班打卡时间',prop: 'checkOutTime',check: true,fixed: undefined},
        {label: '下班打卡地点',prop: 'checkOutLocation',check: true,fixed: undefined},
        {label: '迟到(分)',prop: 'lateMinutes',check: true,fixed: undefined},
        {label: '早退(分)',prop: 'earlyLeaveMinutes',check: true,fixed: undefined},
        {label: '当天工作时长',prop: 'workHours',check: true,fixed: undefined},
        {label: '午休时间',prop: 'lunchBreak',check: true,fixed: undefined},
        {label: '备注',prop: 'remark',check: true,fixed: undefined},
        {label: '创建时间',prop: 'createTime',check: true,fixed: undefined},
    ],
    configDefaultPropColumn: [],
    isConfigMode: false,
    configModeForm: {
        name: '',
        remark: '',
        defaultOrNot: '0'
    },
    configDefaultPropColumnMap: new Map(),
}
